var _style, _g, _rect, _rect2, _g2, _polygon, _polygon2, _rect3, _path, _g3, _line, _line2, _line3, _line4, _line5, _line6, _polyline, _polyline2, _polyline3, _path2, _path3, _g4, _g5, _polygon3, _polygon4, _polygon5, _polygon6, _circle, _circle2, _g6, _circle3, _g7, _circle4, _circle5, _circle6, _g8, _circle7, _g9, _circle8, _circle9, _circle10, _g10, _circle11, _g11, _circle12, _g12, _g13, _circle13, _circle14, _polygon7, _polygon8, _rect4, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _circle15, _circle16, _rect5, _circle17, _circle18, _path4, _path5, _path6, _polygon9, _rect6, _polygon10, _path7, _g21, _circle19, _circle20, _circle21, _circle22, _path8, _circle23, _circle24, _rect7, _circle25, _circle26, _path9, _path10, _path11, _polygon11, _rect8, _polygon12, _path12, _g22, _circle27, _circle28, _circle29, _circle30, _path13, _circle31, _circle32, _circle33, _circle34, _path14, _g23, _g24, _g25, _g26, _g27, _g28, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _g29, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _g30, _g31, _circle53, _circle54, _circle55, _g32, _g33, _g34, _g35, _polygon13, _polygon14, _polygon15, _polygon16, _g36, _polygon17, _polygon18, _polygon19, _polygon20, _g37, _polygon21, _polygon22, _polygon23, _polygon24, _g38, _circle56, _circle57, _circle58, _g39, _g40, _g41, _g42, _polygon25, _polygon26, _polygon27, _polygon28, _g43, _polygon29, _polygon30, _polygon31, _polygon32, _g44, _polygon33, _polygon34, _polygon35, _polygon36, _g45, _rect9, _rect10, _rect11, _rect12, _g46, _circle59, _circle60, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEviveIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "116px",
    height: "128px",
    viewBox: "0 0 116 128",
    style: {
      enableBackground: "new 0 0 116 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9F9F9;}\r\n\t.st1{fill:#BCBCBC;}\r\n\t.st2{fill:#BFBFBF;enable-background:new    ;}\r\n\t.st3{fill:#DDDDDD;}\r\n\t.st4{fill:#CECECE;enable-background:new    ;}\r\n\t.st5{fill:#1C75BC;}\r\n\t.st6{fill:#E6E6E6;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:4.3739;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#E6E6E6;stroke-width:0.18;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#E6E6E6;stroke-width:0.2249;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#E6E6E6;stroke-width:0.2699;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#1E75BB;}\r\n\t.st12{fill:#0D00B7;}\r\n\t.st13{fill:#130387;}\r\n\t.st14{fill:#1B15FF;}\r\n\t.st15{fill:#E6E6E8;}\r\n\t.st16{fill:#C1C1C1;}\r\n\t.st17{fill:#303030;}\r\n\t.st18{fill:#3A3A3A;}\r\n\t.st19{fill:#282828;}\r\n\t.st20{fill:#636363;}\r\n\t.st21{fill:#B50000;}\r\n\t.st22{fill:#870202;}\r\n\t.st23{fill:#F20303;}\r\n\t.st24{display:none;fill:#0F7391;}\r\n\t.st25{fill:#D6D6D6;stroke:#9A916C;stroke-width:0.3216;}\r\n\t.st26{fill:#9A916C;}\r\n\t.st27{fill:none;stroke:#9A916C;stroke-width:0.2535;}\r\n\t.st28{fill:#404040;}\r\n\t.st29{fill:#2A2A29;}\r\n\t.st30{fill:#474747;}\r\n\t.st31{fill:#595959;}\r\n\t.st32{fill:#373737;}\r\n\t.st33{fill:none;stroke:#9A916C;stroke-width:0.3216;}\r\n\t.st34{fill:#8D8C8C;}\r\n\t.st35{fill:#8C8663;}\r\n\t.st36{fill:#B8AF82;}\r\n\t.st37{fill:#80795B;}\r\n\t.st38{fill:#5E5B43;}\r\n\t.st39{fill:#D9D9D9;}\r\n\t.st40{fill:#CCC9C9;}\r\n\t.st41{fill:#BFBFBF;}\r\n\t.st42{fill:#383838;}\r\n\t.st43{fill:#C4C4C4;}\r\n\t.st44{fill:#A3A3A3;}\r\n\t.st45{fill:#B7B7B7;}\r\n\t.st46{fill:#C1C1C1;stroke:#878787;stroke-width:0.1562;enable-background:new    ;}\r\n\t.st47{fill:#E5E5E5;}\r\n\t.st48{fill:#8C8C8C;}\r\n\t.st49{fill:#C9C7C7;}\r\n\t.st50{fill:#E0FCE0;}\r\n\t.st51{fill:#F9E4E4;}\r\n\t.st52{fill:#A2F76B;stroke:#51DD1D;stroke-width:0.1562;enable-background:new    ;}\r\n\t.st53{fill:#D7F9C0;enable-background:new    ;}\r\n\t.st54{opacity:0.5;fill:#8BEA4E;enable-background:new    ;}\r\n\t.st55{fill:#FFD78F;stroke:#FFAD36;stroke-width:0.1562;enable-background:new    ;}\r\n\t.st56{fill:#FFE6BD;enable-background:new    ;}\r\n\t.st57{opacity:0.5;fill:#FFBE57;enable-background:new    ;}\r\n\t.st58{fill:#FC6D6D;stroke:#FF4040;stroke-width:0.1562;enable-background:new    ;}\r\n\t.st59{fill:#F7BCBC;enable-background:new    ;}\r\n\t.st60{opacity:0.5;fill:#FF4040;enable-background:new    ;}\r\n\t.st61{fill:#878787;stroke:#777777;stroke-width:0.3124;}\r\n\t.st62{fill:#878787;}\r\n\t.st63{fill:#515151;}\r\n\t.st64{fill:#7A7A7A;}\r\n\t.st65{fill:#353535;}\r\n\t.st66{fill:#666666;}\r\n\t.st67{fill:#B3B3B3;}\r\n\t.st68{fill-opacity:0.25;}\r\n\t.st69{fill:#CCCCCC;fill-opacity:0.36;}\r\n\t.st70{fill:#3F3F3F;}\r\n\t.st71{fill:#313131;}\r\n\t.st72{opacity:0.6;fill:#232323;enable-background:new    ;}\r\n\t.st73{fill:#3D3D3D;}\r\n\t.st74{fill:#A9A9AA;}\r\n\t.st75{fill:#510000;}\r\n\t.st76{fill:#890D00;}\r\n\t.st77{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st78{fill:#CECECE;}\r\n\t.st79{fill:#EAEAEA;}\r\n\t.st80{fill:#A5A5A5;}\r\n\t.st81{display:none;fill:#F2F2F2;}\r\n\t.st82{display:none;opacity:0.2;enable-background:new    ;}\r\n\t.st83{fill:#1A1A1A;}\r\n\t.st84{fill:#333333;}\r\n\t.st85{opacity:0.2;enable-background:new    ;}\r\n\t.st86{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st87{fill:none;stroke:#9A916C;stroke-width:0.3487;}\r\n\t.st88{fill:none;stroke:#303030;stroke-width:0.3124;stroke-miterlimit:10;}\r\n\t.st89{fill:#A39D28;}\r\n\t.st90{fill:#141414;}\r\n\t.st91{fill:#1F1F1F;}\r\n\t.st92{fill:#1C1C1C;}\r\n\t.st93{fill:#262626;}\r\n\t.st94{fill:#212121;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "top"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,127c-5.4,0-9.7-4.4-9.7-9.7V10.7C5.6,5.4,10,1,15.4,1h85.2c5.4,0,9.7,4.4,9.7,9.7v106.5 c0,5.4-4.4,9.7-9.7,9.7H15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.6,2c4.8,0,8.7,3.9,8.7,8.7v106.5c0,4.8-3.9,8.7-8.7,8.7H15.4c-4.8,0-8.7-3.9-8.7-8.7V10.7 c0-4.8,3.9-8.7,8.7-8.7H100.6 M100.6,0H15.4C9.5,0,4.6,4.8,4.6,10.7v106.5c0,5.9,4.8,10.7,10.7,10.7h85.2c5.9,0,10.7-4.8,10.7-10.7 V10.7C111.4,4.8,106.5,0,100.6,0L100.6,0z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 52.8,
    className: "st2",
    width: 2.2,
    height: 57.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 52.8,
    className: "st2",
    width: 2.1,
    height: 57.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.6,73.2l0,8.4h1.7C8.4,79.4,6.6,75.3,6.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.6,89.9c0-2.1,1.8-6.2,1.7-8.4H6.6L6.6,89.9z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "108.2,108.5 7.9,108.5 7.8,110.3 108.3,110.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "108.2,54.6 7.9,54.6 7.8,52.8 108.3,52.8 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8,
    y: 54.6,
    className: "st5",
    width: 98.5,
    height: 54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "OSH",
    className: "st6",
    d: "M101.4,61.1l-0.9-0.2c0,0,0,0-0.1,0l-0.3-0.7c0,0,0-0.1,0-0.1l0.5-0.8c0,0,0,0,0-0.1l-0.7-0.7 c0,0,0,0-0.1,0l-0.8,0.5c0,0-0.1,0-0.1,0l-0.6-0.3c0,0,0,0,0-0.1l-0.2-1c0,0,0,0,0,0h-1c0,0,0,0,0,0l-0.2,1c0,0,0,0,0,0.1l-0.6,0.3 c0,0-0.1,0-0.1,0l-0.8-0.5c0,0,0,0-0.1,0l-0.7,0.7c0,0,0,0,0,0.1l0.5,0.8c0,0,0,0.1,0,0.1l-0.3,0.7c0,0,0,0-0.1,0l-0.9,0.2 c0,0,0,0,0,0l0,1c0,0,0,0,0,0l0.9,0.2c0,0,0,0,0.1,0l0.3,0.7c0,0,0,0.1,0,0.1l-0.5,0.7c0,0,0,0,0,0.1l0.7,0.7c0,0,0,0,0.1,0l0.7-0.5 c0,0,0.1,0,0.1,0l0.3,0.2c0,0,0,0,0.1,0l0.7-1.6c0,0,0,0,0-0.1l-0.1,0c0,0,0,0-0.1,0c-0.3-0.2-0.5-0.5-0.5-0.9 c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1c0,0.4-0.2,0.7-0.5,0.9c0,0,0,0-0.1,0l-0.1,0c0,0,0,0,0,0.1l0.7,1.6c0,0,0,0,0.1,0l0.3-0.2 c0,0,0.1,0,0.1,0l0.7,0.5c0,0,0,0,0.1,0l0.7-0.7c0,0,0,0,0-0.1l-0.5-0.7c0,0,0-0.1,0-0.1l0.3-0.7c0,0,0,0,0.1,0l0.9-0.2c0,0,0,0,0,0 L101.4,61.1C101.4,61.1,101.4,61.1,101.4,61.1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "evieLogoText"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.3,92.6l1.1-1.9c0.1-0.1,0-0.3-0.1-0.3c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.2,0-0.3,0.1l-0.8,1.4 c-0.1,0.1-0.3,0.1-0.4,0l-0.8-1.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.1,0.3l1.1,1.9 c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.4,0.1C98.1,92.7,98.2,92.7,98.3,92.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.8,93.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.3-0.1,0.4c0,0.1,0,0.2,0.1,0.3 l1.9,1.1c0.1,0.1,0.3,0,0.3-0.1c0.2-0.5,0.4-1,0.4-1.6c0-0.6-0.1-1.1-0.4-1.6c-0.1-0.1-0.2-0.2-0.3-0.1L98.8,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.9,97.2c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.1-0.3l-1.1-1.9c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2,0-0.3,0.1l-1.1,1.9c-0.1,0.1,0,0.3,0.1,0.3c0.1,0.1,0.2,0.1,0.4,0.2 c0.1,0,0.2,0,0.3-0.1l0.8-1.4c0.1-0.1,0.3-0.1,0.4,0l0.8,1.4C98.7,97.2,98.8,97.2,98.9,97.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 97.7,
    cy: 93.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.8,95.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M94.9,91.3c-0.6,0.6-0.9,1.5-0.9,2.4c0,0.9,0.3,1.8,0.9,2.4c0,0,0,0,0.1,0c0.1,0.1,0.2,0.1,0.2,0l0,0 c0,0,0,0,0,0l0.3-0.3c0,0,0,0,0,0l0.4-0.4l0,0l0.3-0.3c0,0,0,0,0,0l0.7-0.7c0.1-0.1,0.1-0.2,0-0.2l0,0c0,0,0,0,0,0 c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0-0.2,0-0.3l-0.1-0.1c-0.1-0.1-0.3-0.1-0.3,0c-0.2,0.3-0.3,0.6-0.3,1 c0,0.3,0.1,0.5,0.2,0.8L96,94.7c-0.2-0.3-0.3-0.6-0.3-1c0-0.5,0.2-0.9,0.4-1.2c0.1-0.1,0.1-0.2,0-0.3L96,92.1 c-0.1-0.1-0.2-0.1-0.3,0c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.4-0.3,0.8-0.3,1.2c0,0.5,0.1,0.9,0.4,1.3l-0.3,0.2 c-0.3-0.5-0.5-1-0.5-1.5c0-0.5,0.1-1,0.4-1.4c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.1,0.1-0.2,0-0.3l-0.3-0.3 C95.1,91.2,95,91.2,94.9,91.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.2,86.3c0-0.4,0.1-0.6,0.2-0.8c0.2-0.2,0.4-0.2,0.7-0.2c0.3,0,0.5,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.8 v1.5h0.2c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.4v-1.9h0.6v1.9c0,0.2,0,0.4-0.1,0.5c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1h-1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3 c0-0.1-0.1-0.3-0.1-0.5V86.3z M97.5,87.7v-1.4c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.1-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.1,0.2-0.1,0.3v1c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.3,0.1H97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.2,84.3l2.4-1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2l-2.4-1.1v-0.7l2.6,1.2c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3l-2.6,1.1V84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.2,80h2.9v0.6h-2.9V80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.2,78.8l2.4-1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2l-2.4-1.1v-0.7l2.6,1.2c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3l-2.6,1.1V78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.2,73.4c0-0.4,0.1-0.6,0.2-0.8c0.2-0.2,0.4-0.2,0.7-0.2c0.3,0,0.5,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.8 v1.5h0.2c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.4v-1.9h0.6v1.9c0,0.2,0,0.4-0.1,0.5c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1h-1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3 c0-0.1-0.1-0.3-0.1-0.5V73.4z M97.5,74.9v-1.4c0-0.2,0-0.3-0.1-0.4C97.3,73,97.2,73,97.1,73c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.1,0.2-0.1,0.3v1c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.3,0.1H97.5z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 29.5,
    y1: 73.7,
    x2: 34,
    y2: 73.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 34,
    y1: 77.3,
    x2: 34,
    y2: 73.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 32.5,
    y1: 78.7,
    x2: 34,
    y2: 77.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 30.9,
    y1: 78.7,
    x2: 32.5,
    y2: 78.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 29.5,
    y1: 77.3,
    x2: 29.5,
    y2: 73.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 29.5,
    y1: 77.3,
    x2: 30.9,
    y2: 78.7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "32.2,71.3 32.2,71.3 32.2,71.2 32.1,71.2 32.1,71.1 32.1,71.1 32,71.1 32,71.1 31.9,71.1 31.9,71  31.8,71 31.7,71 31.7,71 31.6,71 31.6,71 31.5,71 31.5,71 31.4,71 31.4,71 31.3,71.1 31.3,71.1 31.2,71.1 31.2,71.1 31.1,71.1  31.1,71.2 31.1,71.2 31,71.3 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "32.6,70.7 32.6,70.7 32.6,70.7 32.5,70.6 32.4,70.5 32.3,70.5 32.2,70.4 32.1,70.4 32,70.4 32,70.4  31.8,70.3 31.7,70.3 31.6,70.3 31.5,70.3 31.4,70.3 31.3,70.3 31.2,70.4 31.1,70.4 31.1,70.4 30.9,70.5 30.9,70.5 30.8,70.6  30.7,70.6 30.6,70.7 30.6,70.7 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "31.7,71.8 31.7,71.8 31.7,71.7 31.7,71.7 31.7,71.7 31.7,71.7 31.7,71.7 31.7,71.7 31.7,71.7  31.7,71.7 31.7,71.6 31.6,71.6 31.6,71.6 31.6,71.6 31.6,71.6 31.5,71.7 31.5,71.7 31.5,71.7 31.5,71.7 31.5,71.7 31.5,71.7  31.5,71.7 31.5,71.7 31.5,71.8 31.5,71.8 31.5,71.8 31.5,71.8 31.5,71.8 31.5,71.9 31.5,71.9 31.5,71.9 31.5,71.9 31.6,71.9  31.6,71.9 31.6,71.9 31.6,71.9 31.7,71.9 31.7,71.9 31.7,71.9 31.7,71.9 31.7,71.9 31.7,71.8 31.7,71.8 31.7,71.8 31.7,71.8  31.7,71.8 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.9,25.6c-2.6,0-4.7,2.1-4.7,4.7c0,1.3,0.5,2.4,1.4,3.3l0.3-0.3c-0.8-0.8-1.2-1.8-1.2-3 c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2c0,1.2-0.5,2.2-1.2,3l0.3,0.3c0.8-0.8,1.4-2,1.4-3.3C67.5,27.7,65.5,25.6,62.9,25.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.9,40.8c-2.6,0-4.7,2.1-4.7,4.7c0,1.3,0.5,2.4,1.4,3.3l0.3-0.3c-0.8-0.8-1.2-1.8-1.2-3 c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2c0,1.2-0.5,2.2-1.2,3l0.3,0.3c0.8-0.8,1.4-2,1.4-3.3C67.5,42.8,65.5,40.8,62.9,40.8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.3,48.3L27.3,48.3C27.3,48.3,27.3,48.4,27.3,48.3L27.3,50c0,0,0,0.1,0.1,0.1h3.2c0,0,0.1,0,0.1-0.1v-1.6 c0,0,0-0.1-0.1-0.1H27.3z M27.3,47.9L27.3,47.9h3.2c0.3,0,0.5,0.2,0.5,0.5V50c0,0.3-0.2,0.5-0.5,0.5h-3.2c-0.3,0-0.5-0.2-0.5-0.5 v-0.4h-0.2c-0.1,0-0.2-0.1-0.2-0.2v-0.5c0-0.1,0.1-0.2,0.2-0.2h0.2v-0.4C26.9,48.1,27.1,47.9,27.3,47.9z M28.8,48.6 c0.4,0.2,0.9,0.5,1.3,0.7c0,0,0,0,0,0c0,0,0.1,0,0,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4-0.1-0.6-0.1c0,0,0,0-0.1,0 c0,0,0,0,0,0.1c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1-0.1,0.1c-0.4-0.2-0.9-0.5-1.3-0.7c0,0,0,0,0,0c0,0-0.1,0,0-0.1c0,0,0.1,0,0.1,0 c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.6,0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0-0.1,0-0.3,0-0.4C28.7,48.6,28.8,48.5,28.8,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.7,48C35.7,48,35.7,48,35.7,48c-0.1,0-0.1-0.1-0.1-0.1v-0.2c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0 l-0.7,0.5l0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0l0.3,0.2l0.4,0.3l0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1v-0.2 c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.4,0.1,0.8,0.4,0.8,0.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9 c0-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0,0c0.1-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2,0-0.3,0.1h0c-0.1,0.2-0.2,0.5-0.2,0.7 c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3C36.9,48.7,36.4,48.1,35.7,48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.8,49.3c0-0.4,0.2-0.7,0.3-0.9c0.2-0.2,0.3-0.3,0.3-0.3c0.1-0.1,0.2,0,0.3,0.1c0.1,0.1,0,0.2-0.1,0.3v0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.3-0.2,0.6c0,0.3,0.1,0.5,0.3,0.7 c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.2-0.2-0.2-0.2l0,0l0,0 c0,0,0,0,0,0h0c0,0,0,0,0,0c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.2,0.1,0.3,0.3c0.2,0.2,0.3,0.5,0.3,0.9 c0,0.8-0.6,1.5-1.4,1.5C21.5,50.7,20.8,50.1,20.8,49.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22,49.2v-0.7v-0.7c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2v0.7v0.7h0c0,0.1-0.1,0.2-0.2,0.2 C22.1,49.4,22,49.3,22,49.2"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "eviveLogo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.7,13c0.7,0,1.2,0.1,1.5,0.4c0.3,0.3,0.5,0.7,0.5,1.2c0,0.5-0.1,0.9-0.4,1.2c-0.3,0.3-0.8,0.4-1.5,0.4H74 v0.4c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.4,0.2,0.7,0.2h3.5v1.1h-3.5c-0.4,0-0.7,0-0.9-0.1s-0.5-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.3-0.6 c-0.1-0.2-0.1-0.5-0.1-0.7v-1.9c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.2,0.4-0.3,0.6-0.4c0.2-0.1,0.5-0.1,0.9-0.1 H76.7z M74,15.4h2.7c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.6-0.2h-1.8 c-0.3,0-0.5,0.1-0.7,0.2C74,14.4,74,14.6,74,14.8V15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80.4,13l1.9,4.4c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2l2-4.4H86l-2.2,4.8c-0.1,0.3-0.3,0.4-0.5,0.6 s-0.5,0.2-0.8,0.2c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.3-0.5-0.5L79.2,13H80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.2,13v5.4H87V13H88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M90.4,13l1.9,4.4c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2l2-4.4h1.2l-2.2,4.8c-0.1,0.3-0.3,0.4-0.5,0.6 s-0.5,0.2-0.8,0.2c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.3-0.5-0.5L89.2,13H90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.5,13c0.7,0,1.2,0.1,1.5,0.4c0.3,0.3,0.5,0.7,0.5,1.2c0,0.5-0.1,0.9-0.4,1.2c-0.3,0.3-0.8,0.4-1.5,0.4 h-2.7v0.4c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.4,0.2,0.7,0.2h3.5v1.1h-3.5c-0.4,0-0.7,0-0.9-0.1c-0.2-0.1-0.5-0.2-0.6-0.4 c-0.2-0.2-0.3-0.4-0.3-0.6c-0.1-0.2-0.1-0.5-0.1-0.7v-1.9c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.2,0.4-0.3,0.6-0.4 c0.2-0.1,0.5-0.1,0.9-0.1H100.5z M97.8,15.4h2.7c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5 c-0.1-0.1-0.3-0.2-0.6-0.2h-1.8c-0.3,0-0.5,0.1-0.7,0.2c-0.1,0.1-0.2,0.3-0.2,0.5V15.4z"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "62.9,10.2 62.5,10.5 62,10.9 62.9,10.9 63.8,10.9 63.3,10.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "62.9,20.8 63.3,20.4 63.8,20.1 62.9,20.1 62,20.1 62.5,20.4 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "57.6,15.2 57.9,15.7 58.3,16.1 58.3,15.2 58.3,14.3 57.9,14.8 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "68.2,15.2 67.9,14.8 67.5,14.3 67.5,15.2 67.5,16.1 67.9,15.7 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 71.5,
    cy: 117.1,
    r: 5.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 71.5,
    cy: 117,
    r: 3.9
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M71.8,112l-0.3-0.3c-2.9,0.1-5.3,2.5-5.5,5.4l0.3,0.4C66.5,114.5,68.9,112.1,71.8,112z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 71.5,
    cy: 117.1,
    r: 2.2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M69.8,117.1c0-0.9,0.6-1.6,1.4-1.7V114c-1.6,0.2-2.8,1.5-2.8,3.1c0,1.6,1.2,2.9,2.8,3.1v-1.3 C70.4,118.7,69.8,117.9,69.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M74.6,117.1c0-1.6-1.2-2.9-2.7-3.1v1.3c0.8,0.2,1.4,0.9,1.4,1.7c0,0.9-0.6,1.6-1.4,1.7v1.3 C73.4,120,74.6,118.6,74.6,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M69.8,117.1c0,0.9,0.6,1.6,1.4,1.7v-3.5C70.4,115.5,69.8,116.2,69.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M73.3,117.1c0-0.9-0.6-1.6-1.4-1.7v3.5C72.7,118.7,73.3,117.9,73.3,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M71.6,118.8c-0.1,0-0.2,0-0.3,0v1.3c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0v-1.3 C71.8,118.8,71.7,118.8,71.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M71.6,115.3c0.1,0,0.2,0,0.3,0V114c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.3,0v1.3 C71.3,115.3,71.4,115.3,71.6,115.3z"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "connector528pin",
    className: "st17",
    cx: 71.6,
    cy: 117.1,
    r: 1.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 84.6,
    cy: 117.1,
    r: 5.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 84.6,
    cy: 117,
    r: 3.9
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M84.9,112l-0.3-0.3c-2.9,0.1-5.3,2.5-5.5,5.4l0.3,0.4C79.6,114.5,81.9,112.1,84.9,112z"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 84.6,
    cy: 117.1,
    r: 2.2
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.8,117.1c0-0.9,0.6-1.6,1.4-1.7V114c-1.6,0.2-2.8,1.5-2.8,3.1c0,1.6,1.2,2.9,2.8,3.1v-1.3 C83.4,118.7,82.8,117.9,82.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87.6,117.1c0-1.6-1.2-2.9-2.7-3.1v1.3c0.8,0.2,1.4,0.9,1.4,1.7c0,0.9-0.6,1.6-1.4,1.7v1.3 C86.5,120,87.6,118.6,87.6,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M82.8,117.1c0,0.9,0.6,1.6,1.4,1.7v-3.5C83.4,115.5,82.8,116.2,82.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M86.4,117.1c0-0.9-0.6-1.6-1.4-1.7v3.5C85.7,118.7,86.4,117.9,86.4,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.6,118.8c-0.1,0-0.2,0-0.3,0v1.3c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0v-1.3 C84.8,118.8,84.7,118.8,84.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.6,115.3c0.1,0,0.2,0,0.3,0V114c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.3,0v1.3 C84.4,115.3,84.5,115.3,84.6,115.3z"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "connector529pin",
    className: "st17",
    cx: 84.6,
    cy: 117.1,
    r: 1.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 97.6,
    cy: 117.1,
    r: 5.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 97.6,
    cy: 117,
    r: 3.9
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M97.9,112l-0.3-0.3c-2.9,0.1-5.3,2.5-5.5,5.4l0.3,0.4C92.6,114.5,94.9,112.1,97.9,112z"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 97.6,
    cy: 117.1,
    r: 2.2
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M95.8,117.1c0-0.9,0.6-1.6,1.4-1.7V114c-1.6,0.2-2.8,1.5-2.8,3.1c0,1.6,1.2,2.9,2.8,3.1v-1.3 C96.5,118.7,95.8,117.9,95.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100.7,117.1c0-1.6-1.2-2.9-2.7-3.1v1.3c0.8,0.2,1.4,0.9,1.4,1.7c0,0.9-0.6,1.6-1.4,1.7v1.3 C99.5,120,100.7,118.6,100.7,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M95.8,117.1c0,0.9,0.6,1.6,1.4,1.7v-3.5C96.5,115.5,95.8,116.2,95.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M99.4,117.1c0-0.9-0.6-1.6-1.4-1.7v3.5C98.8,118.7,99.4,117.9,99.4,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.6,118.8c-0.1,0-0.2,0-0.3,0v1.3c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0v-1.3 C97.8,118.8,97.7,118.8,97.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.6,115.3c0.1,0,0.2,0,0.3,0V114c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.3,0v1.3 C97.4,115.3,97.5,115.3,97.6,115.3z"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "connector530pin",
    className: "st17",
    cx: 97.6,
    cy: 117.1,
    r: 1.8
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "ArduinoPinOuts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "breadboardbreadboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M17.6,105l-2.2-2.2v-9l-2.2-2.2V61.2l2.2-2.2v-0.2c0-0.5,0.4-0.9,0.9-0.9l0,0h85.9c0.5,0,0.9,0.4,0.9,0.9 l0,0v45.5c0,0.5-0.4,0.9-0.9,0.9l0,0L17.6,105 M19.1,60c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4 C18.4,61.5,19.1,60.8,19.1,60z M91,102.8c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4l0,0c0,0.8,0.6,1.4,1.4,1.4 C90.4,104.2,91,103.6,91,102.8L91,102.8L91,102.8z M24.7,102.8c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 c0,0.8,0.6,1.4,1.4,1.4C24,104.2,24.7,103.6,24.7,102.8z M92.2,60c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4l0,0 c0,0.8,0.6,1.4,1.4,1.4C91.5,61.5,92.2,60.8,92.2,60L92.2,60z M46,89.3c0-0.8-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4l0,0 c0,0.8,0.6,1.4,1.4,1.4S46,90.1,46,89.3L46,89.3z M46,64.5c0-0.8-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4l0,0c0,0.8,0.6,1.4,1.4,1.4 S46,65.3,46,64.5L46,64.5z M38.3,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C38.1,60.4,38.3,60.2,38.3,60L38.3,60z M36,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C35.9,60.4,36,60.2,36,60L36,60z M33.8,60c0-0.2-0.2-0.4-0.4-0.4S33,59.8,33,60l0,0c0,0.2,0.2,0.4,0.4,0.4S33.8,60.2,33.8,60 L33.8,60z M31.5,60c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4S31.5,60.2,31.5,60L31.5,60z M29.3,60 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4S29.3,60.2,29.3,60L29.3,60z M27,60c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C26.9,60.4,27,60.2,27,60L27,60z M24.8,60c0-0.2-0.2-0.4-0.4-0.4 S24,59.8,24,60l0,0c0,0.2,0.2,0.4,0.4,0.4S24.8,60.2,24.8,60L24.8,60z M22.5,60c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4S22.5,60.2,22.5,60L22.5,60z M58.5,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C58.4,60.4,58.5,60.2,58.5,60L58.5,60z M56.3,60c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4S56.3,60.2,56.3,60L56.3,60z M54,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C53.9,60.4,54,60.2,54,60L54,60z M51.8,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C51.6,60.4,51.8,60.2,51.8,60L51.8,60z M49.5,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C49.4,60.4,49.5,60.2,49.5,60L49.5,60z M47.3,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C47.1,60.4,47.3,60.2,47.3,60L47.3,60z M45,60c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4S45,60.2,45,60L45,60z M42.8,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C42.6,60.4,42.8,60.2,42.8,60L42.8,60z M27,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C26.9,103.2,27,103,27,102.8L27,102.8z M29.3,102.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C29.1,103.2,29.3,103,29.3,102.8L29.3,102.8z M31.5,102.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C31.4,103.2,31.5,103,31.5,102.8L31.5,102.8z M33.8,102.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 S33.8,103,33.8,102.8L33.8,102.8z M36,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C35.9,103.2,36,103,36,102.8L36,102.8z M38.3,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4 C38.1,103.2,38.3,103,38.3,102.8L38.3,102.8z M40.5,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C40.4,103.2,40.5,103,40.5,102.8L40.5,102.8z M42.8,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 l0,0c0,0.2,0.2,0.4,0.4,0.4C42.6,103.2,42.8,103,42.8,102.8L42.8,102.8z M86.8,102.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4S86.8,103,86.8,102.8L86.8,102.8z M84.6,102.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C84.4,103.2,84.6,103,84.6,102.8L84.6,102.8z M82.3,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 l0,0c0,0.2,0.2,0.4,0.4,0.4C82.2,103.2,82.3,103,82.3,102.8L82.3,102.8z M80.1,102.8c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C79.9,103.2,80.1,103,80.1,102.8L80.1,102.8z M77.8,102.8 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C77.7,103.2,77.8,103,77.8,102.8L77.8,102.8z M75.6,102.8 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4S75.6,103,75.6,102.8L75.6,102.8z M73.3,102.8 c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C73.2,103.2,73.3,103,73.3,102.8L73.3,102.8z  M71.1,102.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4S71.1,103,71.1,102.8L71.1,102.8z M68.9,102.8 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C68.7,103.2,68.9,103,68.9,102.8L68.9,102.8L68.9,102.8z  M66.6,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C66.4,103.2,66.6,103,66.6,102.8 L66.6,102.8z M78.8,60c0-0.2-0.2-0.4-0.4-0.4S78,59.8,78,60l0,0c0,0.2,0.2,0.4,0.4,0.4S78.8,60.3,78.8,60L78.8,60z M76.5,60 c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C76.3,60.4,76.5,60.3,76.5,60L76.5,60z M74.3,60 c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C74.1,60.4,74.3,60.3,74.3,60L74.3,60z M72,60 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4S72,60.3,72,60L72,60z M69.8,60c0-0.2-0.2-0.4-0.4-0.4 S69,59.8,69,60l0,0c0,0.2,0.2,0.4,0.4,0.4S69.8,60.3,69.8,60L69.8,60z M67.5,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 l0,0c0,0.2,0.2,0.4,0.4,0.4C67.4,60.4,67.5,60.2,67.5,60L67.5,60z M65.3,60c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4S65.3,60.2,65.3,60L65.3,60z M63,60c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C62.9,60.4,63,60.2,63,60L63,60z M47.3,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0 c0,0.2,0.2,0.4,0.4,0.4C47.1,103.2,47.3,103,47.3,102.8L47.3,102.8z M49.5,102.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 l0,0c0,0.2,0.2,0.4,0.4,0.4C49.4,103.2,49.5,103,49.5,102.8L49.5,102.8z M51.8,102.8c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C51.6,103.2,51.8,103,51.8,102.8L51.8,102.8z M54,102.8c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C53.9,103.2,54,103,54,102.8L54,102.8z M56.3,102.8c0-0.2-0.2-0.4-0.4-0.4 s-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4S56.3,103,56.3,102.8L56.3,102.8z M58.5,102.8c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C58.4,103.2,58.5,103,58.5,102.8L58.5,102.8z M60.8,102.8 c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C60.6,103.2,60.8,103,60.8,102.8L60.8,102.8z M63,102.8 c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4C62.9,103.2,63,103,63,102.8L63,102.8z M20.3,102.8 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S20.3,103,20.3,102.8z M18.1,102.8c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S18.1,103,18.1,102.8z M20.3,100.5c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 s0.2,0.4,0.4,0.4C20.1,100.9,20.3,100.8,20.3,100.5z M18.1,100.5c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4 C17.9,100.9,18.1,100.8,18.1,100.5z M20.3,98.3c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4S20.3,98.5,20.3,98.3 L20.3,98.3z M18.1,98.3c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4S18.1,98.5,18.1,98.3L18.1,98.3z M20.3,96 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S20.3,96.3,20.3,96z M18.1,96c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S18.1,96.3,18.1,96z M20.3,93.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4C20.1,94.2,20.3,94,20.3,93.8z M18.1,93.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4C17.9,94.2,18.1,94,18.1,93.8z M20.3,91.5c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4 S20.3,91.8,20.3,91.5L20.3,91.5z M18.1,91.5c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4S18.1,91.8,18.1,91.5 L18.1,91.5z M20.3,89.3c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4C20.1,89.7,20.3,89.5,20.3,89.3L20.3,89.3z  M18.1,89.3c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4C17.9,89.7,18.1,89.5,18.1,89.3L18.1,89.3z  M20.3,87c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4S20.3,87.3,20.3,87z M18.1,87c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4S18.1,87.3,18.1,87z M20.3,84.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4S20.3,85,20.3,84.8z M18.1,84.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4 S18.1,85,18.1,84.8z M20.3,82.5c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4C20.1,82.9,20.3,82.8,20.3,82.5z  M18.1,82.5c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4C17.9,82.9,18.1,82.8,18.1,82.5z M20.3,80.3 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S20.3,80.5,20.3,80.3z M18.1,80.3c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S18.1,80.5,18.1,80.3z M20.3,78c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4C20.1,78.4,20.3,78.3,20.3,78L20.3,78z M18.1,78c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4C17.9,78.4,18.1,78.3,18.1,78L18.1,78z M20.3,75.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4S20.3,76,20.3,75.8z M18.1,75.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4 S18.1,76,18.1,75.8z M20.3,73.5c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S20.3,73.8,20.3,73.5L20.3,73.5z  M18.1,73.5c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S18.1,73.8,18.1,73.5L18.1,73.5z M20.3,71.3 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4C20.1,71.7,20.3,71.5,20.3,71.3z M18.1,71.3 c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4C17.9,71.7,18.1,71.5,18.1,71.3z M20.3,69 c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S20.3,69.3,20.3,69z M18.1,69c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S18.1,69.3,18.1,69z M20.3,66.8c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4C20.1,67.2,20.3,67,20.3,66.8z M18.1,66.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4C17.9,67.2,18.1,67,18.1,66.8z M20.3,64.5c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4 S20.3,64.8,20.3,64.5z M18.1,64.5c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4S18.1,64.8,18.1,64.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector0pin",
    className: "st25",
    cx: 37.9,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M38.4,61.2h-1v-2.3h1V61.2 M38.4,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C38.2,60.5,38.4,60.3,38.4,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector1pin",
    className: "st25",
    cx: 35.6,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M36.1,61.2h-1v-2.3h1V61.2 M36.1,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C35.9,60.5,36.1,60.3,36.1,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector2pin",
    className: "st25",
    cx: 33.4,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M33.9,61.2h-1v-2.3h1V61.2 M33.9,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S33.9,60.3,33.9,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector3pin",
    className: "st25",
    cx: 31.1,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M31.6,61.2h-1v-2.3h1V61.2 M31.6,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S31.6,60.3,31.6,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector4pin",
    className: "st27",
    cx: 28.9,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M29.4,61.2h-1v-2.3h1V61.2 M29.4,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 C29.2,60.5,29.4,60.3,29.4,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector5pin",
    className: "st27",
    cx: 26.6,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M27.1,61.2h-1v-2.3h1V61.2 M27.1,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C26.9,60.5,27.1,60.3,27.1,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector6pin",
    className: "st27",
    cx: 24.4,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M24.9,61.2h-1v-2.3h1V61.2 M24.9,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S24.9,60.3,24.9,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector7pin",
    className: "st27",
    cx: 22.1,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M22.6,61.2h-1v-2.3h1V61.2 M22.6,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S22.6,60.3,22.6,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector8pin",
    className: "st27",
    cx: 58.1,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M58.6,61.2h-1v-2.3h1V61.2 M58.6,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C58.4,60.5,58.6,60.3,58.6,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector9pin",
    className: "st27",
    cx: 55.9,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M56.4,61.2h-1v-2.3h1V61.2 M56.4,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S56.4,60.3,56.4,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector10pin",
    className: "st27",
    cx: 53.6,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M54.1,61.2h-1v-2.3h1V61.2 M54.1,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C53.9,60.5,54.1,60.3,54.1,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector11pin",
    className: "st27",
    cx: 51.4,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M51.9,61.2h-1v-2.3h1V61.2 M51.9,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C51.7,60.5,51.9,60.3,51.9,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector12pin",
    className: "st27",
    cx: 49.1,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M49.6,61.2h-1v-2.3h1V61.2 M49.6,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C49.4,60.5,49.6,60.3,49.6,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector13pin",
    className: "st27",
    cx: 46.9,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M47.4,61.2h-1v-2.3h1V61.2 M47.4,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C47.2,60.5,47.4,60.3,47.4,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector14pin",
    className: "st25",
    cx: 44.6,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M45.1,61.2h-1v-2.3h1V61.2 M45.1,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S45.1,60.3,45.1,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector15pin",
    className: "st25",
    cx: 42.4,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M42.9,61.2h-1v-2.3h1V61.2 M42.9,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C42.7,60.5,42.9,60.3,42.9,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector46pin",
    className: "st27",
    cx: 26.6,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M27.1,103.9h-1v-2.3h1V103.9 M27.1,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C26.9,103.3,27.1,103.1,27.1,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector47pin",
    className: "st27",
    cx: 28.9,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M29.4,103.9h-1v-2.3h1V103.9 M29.4,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 C29.2,103.3,29.4,103.1,29.4,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector48pin",
    className: "st27",
    cx: 31.1,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M31.6,103.9h-1v-2.3h1V103.9 M31.6,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 S31.6,103.1,31.6,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector49pin",
    className: "st27",
    cx: 33.4,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M33.9,103.9h-1v-2.3h1V103.9 M33.9,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 S33.9,103.1,33.9,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector50pin",
    className: "st27",
    cx: 35.6,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M36.1,103.9h-1v-2.3h1V103.9 M36.1,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C35.9,103.3,36.1,103.1,36.1,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector51pin",
    className: "st27",
    cx: 37.9,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M38.4,103.9h-1v-2.3h1V103.9 M38.4,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C38.2,103.3,38.4,103.1,38.4,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector52pin",
    className: "st27",
    cx: 40.1,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M40.6,103.9h-1v-2.3h1V103.9 M40.6,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C40.4,103.3,40.6,103.1,40.6,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector53pin",
    className: "st27",
    cx: 42.4,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M42.9,103.9h-1v-2.3h1V103.9 M42.9,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C42.7,103.3,42.9,103.1,42.9,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector234pin",
    className: "st27",
    cx: 86.5,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M87,103.9h-1v-2.3h1V103.9 M87,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 C86.8,103.3,87,103.1,87,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector235pin",
    className: "st27",
    cx: 84.2,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M84.7,103.9h-1v-2.3h1V103.9 M84.7,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 S84.7,103.1,84.7,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector236pin",
    className: "st27",
    cx: 82,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M82.5,103.9h-1v-2.3h1V103.9 M82.5,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C82.3,103.3,82.5,103.1,82.5,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector237pin",
    className: "st27",
    cx: 79.7,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M80.2,103.9h-1v-2.3h1V103.9 M80.2,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C80,103.3,80.2,103.1,80.2,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector238pin",
    className: "st27",
    cx: 77.5,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M78,103.9h-1v-2.3h1V103.9 M78,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 C77.8,103.3,78,103.1,78,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector239pin",
    className: "st27",
    cx: 75.2,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M75.7,103.9h-1v-2.3h1V103.9 M75.7,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C75.5,103.3,75.7,103.1,75.7,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector240pin",
    className: "st27",
    cx: 73,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M73.5,103.9h-1v-2.3h1V103.9 M73.5,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C73.3,103.3,73.5,103.1,73.5,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector241pin",
    className: "st27",
    cx: 70.7,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M71.2,103.9h-1v-2.3h1V103.9 M71.2,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 S71.2,103.1,71.2,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector242pin",
    className: "st27",
    cx: 68.5,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M69,103.9h-1v-2.3h1V103.9 M69,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 S69,103.1,69,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector243pin",
    className: "st27",
    cx: 66.2,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M66.7,103.9h-1v-2.3h1V103.9 M66.7,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C66.5,103.3,66.7,103.1,66.7,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector254pin",
    className: "st27",
    cx: 78.4,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M78.9,61.2h-1v-2.3h1V61.2 M78.9,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S78.9,60.3,78.9,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector255pin",
    className: "st27",
    cx: 76.1,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M76.6,61.2h-1v-2.3h1V61.2 M76.6,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C76.4,60.5,76.6,60.3,76.6,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector256pin",
    className: "st27",
    cx: 73.9,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M74.4,61.2h-1v-2.3h1V61.2 M74.4,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C74.2,60.5,74.4,60.3,74.4,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector257pin",
    className: "st27",
    cx: 71.6,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M72.1,61.2h-1v-2.3h1V61.2 M72.1,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S72.1,60.3,72.1,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector258pin",
    className: "st27",
    cx: 69.4,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M69.9,61.2h-1v-2.3h1V61.2 M69.9,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S69.9,60.3,69.9,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector259pin",
    className: "st27",
    cx: 67.1,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M67.6,61.2h-1v-2.3h1V61.2 M67.6,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C67.4,60.5,67.6,60.3,67.6,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector260pin",
    className: "st27",
    cx: 64.9,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M65.4,61.2h-1v-2.3h1V61.2 M65.4,60c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5 S65.4,60.3,65.4,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector261pin",
    className: "st27",
    cx: 62.6,
    cy: 60,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M63.1,61.2h-1v-2.3h1V61.2 M63.1,60c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5l0,0 c0,0.3,0.2,0.5,0.5,0.5C62.9,60.5,63.1,60.3,63.1,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector262pin",
    className: "st27",
    cx: 46.9,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M47.4,103.9h-1v-2.3h1V103.9 M47.4,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C47.2,103.3,47.4,103.1,47.4,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector263pin",
    className: "st27",
    cx: 49.1,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M49.6,103.9h-1v-2.3h1V103.9 M49.6,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C49.4,103.3,49.6,103.1,49.6,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector264pin",
    className: "st27",
    cx: 51.4,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M51.9,103.9h-1v-2.3h1V103.9 M51.9,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C51.7,103.3,51.9,103.1,51.9,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector265pin",
    className: "st27",
    cx: 53.6,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M54.1,103.9h-1v-2.3h1V103.9 M54.1,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C53.9,103.3,54.1,103.1,54.1,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector266pin",
    className: "st27",
    cx: 55.9,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M56.4,103.9h-1v-2.3h1V103.9 M56.4,102.8c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 S56.4,103.1,56.4,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector267pin",
    className: "st27",
    cx: 58.1,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M58.6,103.9h-1v-2.3h1V103.9 M58.6,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C58.4,103.3,58.6,103.1,58.6,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector268pin",
    className: "st27",
    cx: 60.4,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M60.9,103.9h-1v-2.3h1V103.9 M60.9,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C60.7,103.3,60.9,103.1,60.9,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector269pin",
    className: "st27",
    cx: 62.6,
    cy: 102.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M63.1,103.9h-1v-2.3h1V103.9 M63.1,102.8c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5C62.9,103.3,63.1,103.1,63.1,102.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector343pin",
    className: "st25",
    cx: 19.9,
    cy: 102.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector344pin",
    className: "st25",
    cx: 17.6,
    cy: 102.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector345pin",
    className: "st25",
    cx: 19.9,
    cy: 100.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector346pin",
    className: "st25",
    cx: 17.6,
    cy: 100.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector347pin",
    className: "st25",
    cx: 19.9,
    cy: 98.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector348pin",
    className: "st25",
    cx: 17.6,
    cy: 98.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector349pin",
    className: "st25",
    cx: 19.9,
    cy: 96,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector350pin",
    className: "st25",
    cx: 17.6,
    cy: 96,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector351pin",
    className: "st25",
    cx: 19.9,
    cy: 93.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector352pin",
    className: "st25",
    cx: 17.6,
    cy: 93.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector353pin",
    className: "st25",
    cx: 19.9,
    cy: 91.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector354pin",
    className: "st25",
    cx: 17.6,
    cy: 91.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector355pin",
    className: "st25",
    cx: 19.9,
    cy: 89.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector356pin",
    className: "st25",
    cx: 17.6,
    cy: 89.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector357pin",
    className: "st25",
    cx: 19.9,
    cy: 87,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector358pin",
    className: "st25",
    cx: 17.6,
    cy: 87,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector359pin",
    className: "st25",
    cx: 19.9,
    cy: 84.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector360pin",
    className: "st25",
    cx: 17.6,
    cy: 84.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector361pin",
    className: "st25",
    cx: 19.9,
    cy: 82.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector362pin",
    className: "st25",
    cx: 17.6,
    cy: 82.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector363pin",
    className: "st25",
    cx: 19.9,
    cy: 80.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector364pin",
    className: "st25",
    cx: 17.6,
    cy: 80.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector365pin",
    className: "st25",
    cx: 19.9,
    cy: 78,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector366pin",
    className: "st25",
    cx: 17.6,
    cy: 78,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector367pin",
    className: "st25",
    cx: 19.9,
    cy: 75.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector368pin",
    className: "st25",
    cx: 17.6,
    cy: 75.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector369pin",
    className: "st25",
    cx: 19.9,
    cy: 73.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector370pin",
    className: "st25",
    cx: 17.6,
    cy: 73.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector371pin",
    className: "st25",
    cx: 19.9,
    cy: 71.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector372pin",
    className: "st25",
    cx: 17.6,
    cy: 71.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector373pin",
    className: "st25",
    cx: 19.9,
    cy: 69,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector374pin",
    className: "st25",
    cx: 17.6,
    cy: 69,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector375pin",
    className: "st25",
    cx: 19.9,
    cy: 66.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector376pin",
    className: "st25",
    cx: 17.6,
    cy: 66.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector377pin",
    className: "st25",
    cx: 19.9,
    cy: 64.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector378pin",
    className: "st25",
    cx: 17.6,
    cy: 64.5,
    r: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 208.783, 3.59877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_2_"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 57.6, 7.2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: -93.1,
    className: "st28",
    width: 18,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.3,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "240.5,-91.2 240.2,-91.6 239.3,-91.6 239,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "239,-91.2 239.3,-91.6 239.3,-92.4 239,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "239,-92.7 239.3,-92.4 240.2,-92.4 240.5,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "240.5,-92.7 240.2,-92.4 240.2,-91.6 240.5,-91.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "238.2,-91.2 237.9,-91.6 237.1,-91.6 236.7,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "236.7,-91.2 237.1,-91.6 237.1,-92.4 236.7,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "236.7,-92.7 237.1,-92.4 237.9,-92.4 238.2,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "238.2,-92.7 237.9,-92.4 237.9,-91.6 238.2,-91.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.8,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "236,-91.2 235.7,-91.6 234.8,-91.6 234.5,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "234.5,-91.2 234.8,-91.6 234.8,-92.4 234.5,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "234.5,-92.7 234.8,-92.4 235.7,-92.4 236,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "236,-92.7 235.7,-92.4 235.7,-91.6 236,-91.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.6,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "233.7,-91.2 233.4,-91.6 232.6,-91.6 232.2,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "232.2,-91.2 232.6,-91.6 232.6,-92.4 232.2,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "232.2,-92.7 232.6,-92.4 233.4,-92.4 233.7,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "233.7,-92.7 233.4,-92.4 233.4,-91.6 233.7,-91.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.3,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "231.5,-91.2 231.2,-91.6 230.3,-91.6 230,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "230,-91.2 230.3,-91.6 230.3,-92.4 230,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "230,-92.7 230.3,-92.4 231.2,-92.4 231.5,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "231.5,-92.7 231.2,-92.4 231.2,-91.6 231.5,-91.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.1,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "229.2,-91.2 228.9,-91.6 228.1,-91.6 227.7,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "227.7,-91.2 228.1,-91.6 228.1,-92.4 227.7,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "227.7,-92.7 228.1,-92.4 228.9,-92.4 229.2,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "229.2,-92.7 228.9,-92.4 228.9,-91.6 229.2,-91.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.8,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "227,-91.2 226.7,-91.6 225.8,-91.6 225.5,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "225.5,-91.2 225.8,-91.6 225.8,-92.4 225.5,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "225.5,-92.7 225.8,-92.4 226.7,-92.4 227,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "227,-92.7 226.7,-92.4 226.7,-91.6 227,-91.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.6,
    y: -92.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "224.7,-91.2 224.4,-91.6 223.6,-91.6 223.3,-91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "223.3,-91.2 223.6,-91.6 223.6,-92.4 223.3,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "223.3,-92.7 223.6,-92.4 224.4,-92.4 224.7,-92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "224.7,-92.7 224.4,-92.4 224.4,-91.6 224.7,-91.2  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "connector345pin_6_",
    className: "st33",
    cx: 44.7,
    cy: 80.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector346pin_6_",
    className: "st33",
    cx: 47,
    cy: 80.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector347pin_6_",
    className: "st33",
    cx: 44.7,
    cy: 82.7,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector348pin_6_",
    className: "st33",
    cx: 47,
    cy: 82.7,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector349pin_6_",
    className: "st33",
    cx: 44.7,
    cy: 85,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector350pin_6_",
    className: "st33",
    cx: 47,
    cy: 85,
    r: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "44.1,86 45.3,86 46.4,86 47.6,86 48.1,85.5 48.1,84.3 47.6,83.9 46.4,83.9 45.3,83.9 44.1,83.9  43.7,84.3 43.7,85.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "44.1,83.8 45.3,83.8 46.4,83.8 47.6,83.8 48.1,83.3 48.1,82.1 47.6,81.6 46.4,81.6 45.3,81.6  44.1,81.6 43.7,82.1 43.7,83.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "44.1,81.5 45.3,81.5 46.4,81.5 47.6,81.5 48.1,81 48.1,79.8 47.6,79.4 46.4,79.4 45.3,79.4  44.1,79.4 43.7,79.8 43.7,81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "44.1,86 45.3,86 46.4,86 47.6,86 48.1,85.5 48.1,84.3 47.6,83.9 46.4,83.9 45.3,83.9 44.1,83.9  43.7,84.3 43.7,85.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "44.1,83.8 45.3,83.8 46.4,83.8 47.6,83.8 48.1,83.3 48.1,82.1 47.6,81.6 46.4,81.6 45.3,81.6  44.1,81.6 43.7,82.1 43.7,83.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "44.1,81.5 45.3,81.5 46.4,81.5 47.6,81.5 48.1,81 48.1,79.8 47.6,79.4 46.4,79.4 45.3,79.4  44.1,79.4 43.7,79.8 43.7,81  "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0092, 7.2121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "connector704pin",
    x: -73.6,
    y: 46.6,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -120.2522 -26.3013)",
    className: "st34",
    width: 0.7,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -7.189, 14.4123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "connector701pin",
    x: -66.4,
    y: 51.6,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -118.0003 -14.1517)",
    className: "st34",
    width: 0.7,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 7.2065, 14.4123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "connector705pin",
    x: -68.7,
    y: 39.4,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -108.105 -28.5485)",
    className: "st34",
    width: 0.7,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0092, 21.6096)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "connector702pin",
    x: -61.5,
    y: 44.4,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -105.854 -16.4034)",
    className: "st34",
    width: 0.7,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0092, 21.6096)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "connector703pin",
    x: -63.7,
    y: 44.4,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -108.1033 -18.6528)",
    className: "st34",
    width: 0.7,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 14.4038, 21.6095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "connector706pin",
    x: -63.7,
    y: 32.2,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -95.9599 -30.7998)",
    className: "st34",
    width: 0.7,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 7.2063, 28.8115)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -56.3,
    y: 37.3,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -93.6746 -18.6483)",
    className: "st35",
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "45.1,85.3 44.9,85.2 44.6,85.2 44.4,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "44.6,84.8 44.6,85.2 44.4,85.3 44.4,84.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "44.9,84.8 44.6,84.8 44.4,84.6 45.1,84.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "45.1,85.3 44.9,85.2 44.9,84.8 45.1,84.6  "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 14.405, 21.6088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -63.6,
    y: 32.4,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -95.9588 -30.7703)",
    className: "st35",
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "47.3,85.3 47.2,85.2 46.8,85.2 46.6,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "46.8,84.8 46.8,85.2 46.6,85.3 46.6,84.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "47.2,84.8 46.8,84.8 46.6,84.6 47.3,84.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "47.3,85.3 47.2,85.2 47.2,84.8 47.3,84.6  "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.006, 21.6132)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -61.3,
    y: 44.5,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -105.8244 -16.3964)",
    className: "st35",
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "45.1,83.1 44.9,82.9 44.6,82.9 44.4,83.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "44.6,82.5 44.6,82.9 44.4,83.1 44.4,82.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "44.9,82.5 44.6,82.5 44.4,82.4 45.1,82.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "45.1,83.1 44.9,82.9 44.9,82.5 45.1,82.4  "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 7.2077, 14.4115)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -68.5,
    y: 39.6,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -108.0728 -28.5504)",
    className: "st35",
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "47.3,83.1 47.2,82.9 46.8,82.9 46.6,83.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "46.8,82.5 46.8,82.9 46.6,83.1 46.6,82.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "47.2,82.5 46.8,82.5 46.6,82.4 47.3,82.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "47.3,83.1 47.2,82.9 47.2,82.5 47.3,82.4  "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -7.1944, 14.4118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -66.3,
    y: 51.7,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -117.9765 -14.1486)",
    className: "st35",
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "45.1,80.9 44.9,80.7 44.6,80.7 44.4,80.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "44.6,80.3 44.6,80.7 44.4,80.9 44.4,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "44.9,80.3 44.6,80.3 44.4,80.1 45.1,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "45.1,80.9 44.9,80.7 44.9,80.3 45.1,80.1  "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0072, 7.2131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -73.4,
    y: 46.8,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -120.2229 -26.2986)",
    className: "st35",
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "47.3,80.9 47.2,80.7 46.8,80.7 46.6,80.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "46.8,80.3 46.8,80.7 46.6,80.9 46.6,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "47.2,80.3 46.8,80.3 46.6,80.1 47.3,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "47.3,80.9 47.2,80.7 47.2,80.3 47.3,80.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x31_x10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.1,
    y: 101.7,
    className: "st28",
    width: 22.5,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "87.2,103.5 86.9,103.2 86,103.2 85.7,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "85.7,103.5 86,103.2 86,102.4 85.7,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "85.7,102 86,102.4 86.9,102.4 87.2,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "87.2,102 86.9,102.4 86.9,103.2 87.2,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.8,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "85,103.5 84.7,103.2 83.8,103.2 83.5,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "83.5,103.5 83.8,103.2 83.8,102.4 83.5,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "83.5,102 83.8,102.4 84.7,102.4 85,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "85,102 84.7,102.4 84.7,103.2 85,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "82.7,103.5 82.4,103.2 81.5,103.2 81.2,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "81.2,103.5 81.5,103.2 81.5,102.4 81.2,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "81.2,102 81.5,102.4 82.4,102.4 82.7,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "82.7,102 82.4,102.4 82.4,103.2 82.7,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.3,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "80.5,103.5 80.2,103.2 79.3,103.2 79,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "79,103.5 79.3,103.2 79.3,102.4 79,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "79,102 79.3,102.4 80.2,102.4 80.5,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "80.5,102 80.2,102.4 80.2,103.2 80.5,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "78.2,103.5 77.9,103.2 77,103.2 76.7,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "76.7,103.5 77,103.2 77,102.4 76.7,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "76.7,102 77,102.4 77.9,102.4 78.2,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "78.2,102 77.9,102.4 77.9,103.2 78.2,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "76,103.5 75.7,103.2 74.8,103.2 74.5,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "74.5,103.5 74.8,103.2 74.8,102.4 74.5,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "74.5,102 74.8,102.4 75.7,102.4 76,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "76,102 75.7,102.4 75.7,103.2 76,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "73.7,103.5 73.4,103.2 72.5,103.2 72.2,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "72.2,103.5 72.5,103.2 72.5,102.4 72.2,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "72.2,102 72.5,102.4 73.4,102.4 73.7,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "73.7,102 73.4,102.4 73.4,103.2 73.7,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.3,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "71.5,103.5 71.2,103.2 70.3,103.2 70,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "70,103.5 70.3,103.2 70.3,102.4 70,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "70,102 70.3,102.4 71.2,102.4 71.5,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "71.5,102 71.2,102.4 71.2,103.2 71.5,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.1,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "69.2,103.5 68.9,103.2 68.1,103.2 67.7,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "67.7,103.5 68.1,103.2 68.1,102.4 67.7,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "67.7,102 68.1,102.4 68.9,102.4 69.2,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "69.2,102 68.9,102.4 68.9,103.2 69.2,103.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 102.4,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "67,103.5 66.7,103.2 65.8,103.2 65.5,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "65.5,103.5 65.8,103.2 65.8,102.4 65.5,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "65.5,102 65.8,102.4 66.7,102.4 67,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "67,102 66.7,102.4 66.7,103.2 67,103.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_5_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -204.4,
    y: -45.5,
    className: "st28",
    width: 2.2,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -203.7,
    y: -40.3,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-204,-39.1 -203.7,-39.4 -203.7,-40.3 -204,-40.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-204,-40.6 -203.7,-40.3 -202.8,-40.3 -202.5,-40.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-202.5,-40.6 -202.8,-40.3 -202.8,-39.4 -202.5,-39.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-202.5,-39.1 -202.8,-39.4 -203.7,-39.4 -204,-39.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -203.7,
    y: -42.5,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-204,-41.4 -203.7,-41.7 -203.7,-42.5 -204,-42.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-204,-42.9 -203.7,-42.5 -202.8,-42.5 -202.5,-42.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-202.5,-42.9 -202.8,-42.5 -202.8,-41.7 -202.5,-41.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-202.5,-41.4 -202.8,-41.7 -203.7,-41.7 -204,-41.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -203.7,
    y: -44.8,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-204,-43.6 -203.7,-43.9 -203.7,-44.8 -204,-45.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-204,-45.1 -203.7,-44.8 -202.8,-44.8 -202.5,-45.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-202.5,-45.1 -202.8,-44.8 -202.8,-43.9 -202.5,-43.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-202.5,-43.6 -202.8,-43.9 -203.7,-43.9 -204,-43.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_6_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -206.7,
    y: -45.5,
    className: "st28",
    width: 2.2,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -205.9,
    y: -40.3,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-206.3,-39.1 -205.9,-39.4 -205.9,-40.3 -206.3,-40.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-206.3,-40.6 -205.9,-40.3 -205.1,-40.3 -204.7,-40.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-204.7,-40.6 -205.1,-40.3 -205.1,-39.4 -204.7,-39.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-204.7,-39.1 -205.1,-39.4 -205.9,-39.4 -206.3,-39.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -205.9,
    y: -42.5,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-206.3,-41.4 -205.9,-41.7 -205.9,-42.5 -206.3,-42.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-206.3,-42.9 -205.9,-42.5 -205.1,-42.5 -204.7,-42.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-204.7,-42.9 -205.1,-42.5 -205.1,-41.7 -204.7,-41.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-204.7,-41.4 -205.1,-41.7 -205.9,-41.7 -206.3,-41.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -205.9,
    y: -44.8,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-206.3,-43.6 -205.9,-43.9 -205.9,-44.8 -206.3,-45.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-206.3,-45.1 -205.9,-44.8 -205.1,-44.8 -204.7,-45.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-204.7,-45.1 -205.1,-44.8 -205.1,-43.9 -204.7,-43.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-204.7,-43.6 -205.1,-43.9 -205.9,-43.9 -206.3,-43.6  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 58.9,
    className: "st28",
    width: 18,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "79.1,60.8 78.8,60.5 78,60.5 77.6,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "77.6,60.8 78,60.5 78,59.6 77.6,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "77.6,59.3 78,59.6 78.8,59.6 79.1,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "79.1,59.3 78.8,59.6 78.8,60.5 79.1,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.7,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "76.9,60.8 76.6,60.5 75.7,60.5 75.4,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "75.4,60.8 75.7,60.5 75.7,59.6 75.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "75.4,59.3 75.7,59.6 76.6,59.6 76.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "76.9,59.3 76.6,59.6 76.6,60.5 76.9,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "74.6,60.8 74.3,60.5 73.5,60.5 73.1,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "73.1,60.8 73.5,60.5 73.5,59.6 73.1,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "73.1,59.3 73.5,59.6 74.3,59.6 74.6,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "74.6,59.3 74.3,59.6 74.3,60.5 74.6,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "72.4,60.8 72.1,60.5 71.2,60.5 70.9,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "70.9,60.8 71.2,60.5 71.2,59.6 70.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "70.9,59.3 71.2,59.6 72.1,59.6 72.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "72.4,59.3 72.1,59.6 72.1,60.5 72.4,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "70.2,60.8 69.8,60.5 69,60.5 68.6,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "68.6,60.8 69,60.5 69,59.6 68.6,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "68.6,59.3 69,59.6 69.8,59.6 70.2,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "70.2,59.3 69.8,59.6 69.8,60.5 70.2,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.7,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "67.9,60.8 67.6,60.5 66.7,60.5 66.4,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "66.4,60.8 66.7,60.5 66.7,59.6 66.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "66.4,59.3 66.7,59.6 67.6,59.6 67.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "67.9,59.3 67.6,59.6 67.6,60.5 67.9,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "65.7,60.8 65.3,60.5 64.5,60.5 64.1,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "64.1,60.8 64.5,60.5 64.5,59.6 64.1,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "64.1,59.3 64.5,59.6 65.3,59.6 65.7,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "65.7,59.3 65.3,59.6 65.3,60.5 65.7,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.2,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "63.4,60.8 63.1,60.5 62.2,60.5 61.9,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "61.9,60.8 62.2,60.5 62.2,59.6 61.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "61.9,59.3 62.2,59.6 63.1,59.6 63.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "63.4,59.3 63.1,59.6 63.1,60.5 63.4,60.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 58.9,
    className: "st28",
    width: 18,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.7,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "58.9,60.8 58.6,60.5 57.7,60.5 57.4,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "57.4,60.8 57.7,60.5 57.7,59.6 57.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "57.4,59.3 57.7,59.6 58.6,59.6 58.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "58.9,59.3 58.6,59.6 58.6,60.5 58.9,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "56.7,60.8 56.3,60.5 55.5,60.5 55.1,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "55.1,60.8 55.5,60.5 55.5,59.6 55.1,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "55.1,59.3 55.5,59.6 56.3,59.6 56.7,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "56.7,59.3 56.3,59.6 56.3,60.5 56.7,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.2,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "54.4,60.8 54.1,60.5 53.2,60.5 52.9,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "52.9,60.8 53.2,60.5 53.2,59.6 52.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "52.9,59.3 53.2,59.6 54.1,59.6 54.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "54.4,59.3 54.1,59.6 54.1,60.5 54.4,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "52.2,60.8 51.8,60.5 51,60.5 50.6,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "50.6,60.8 51,60.5 51,59.6 50.6,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "50.6,59.3 51,59.6 51.8,59.6 52.2,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "52.2,59.3 51.8,59.6 51.8,60.5 52.2,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "49.9,60.8 49.6,60.5 48.7,60.5 48.4,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "48.4,60.8 48.7,60.5 48.7,59.6 48.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "48.4,59.3 48.7,59.6 49.6,59.6 49.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "49.9,59.3 49.6,59.6 49.6,60.5 49.9,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "47.7,60.8 47.3,60.5 46.5,60.5 46.1,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "46.1,60.8 46.5,60.5 46.5,59.6 46.1,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "46.1,59.3 46.5,59.6 47.3,59.6 47.7,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "47.7,59.3 47.3,59.6 47.3,60.5 47.7,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "45.4,60.8 45.1,60.5 44.2,60.5 43.9,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "43.9,60.8 44.2,60.5 44.2,59.6 43.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "43.9,59.3 44.2,59.6 45.1,59.6 45.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "45.4,59.3 45.1,59.6 45.1,60.5 45.4,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "43.2,60.8 42.8,60.5 42,60.5 41.6,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "41.6,60.8 42,60.5 42,59.6 41.6,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "41.6,59.3 42,59.6 42.8,59.6 43.2,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "43.2,59.3 42.8,59.6 42.8,60.5 43.2,60.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_7_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 58.9,
    className: "st28",
    width: 18,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "38.7,60.8 38.3,60.5 37.5,60.5 37.1,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.1,60.8 37.5,60.5 37.5,59.6 37.1,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "37.1,59.3 37.5,59.6 38.3,59.6 38.7,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.7,59.3 38.3,59.6 38.3,60.5 38.7,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "36.4,60.8 36.1,60.5 35.2,60.5 34.9,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "34.9,60.8 35.2,60.5 35.2,59.6 34.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "34.9,59.3 35.2,59.6 36.1,59.6 36.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "36.4,59.3 36.1,59.6 36.1,60.5 36.4,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "34.2,60.8 33.8,60.5 33,60.5 32.6,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "32.6,60.8 33,60.5 33,59.6 32.6,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "32.6,59.3 33,59.6 33.8,59.6 34.2,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "34.2,59.3 33.8,59.6 33.8,60.5 34.2,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "31.9,60.8 31.6,60.5 30.7,60.5 30.4,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "30.4,60.8 30.7,60.5 30.7,59.6 30.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "30.4,59.3 30.7,59.6 31.6,59.6 31.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "31.9,59.3 31.6,59.6 31.6,60.5 31.9,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "29.7,60.8 29.3,60.5 28.5,60.5 28.1,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "28.1,60.8 28.5,60.5 28.5,59.6 28.1,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "28.1,59.3 28.5,59.6 29.3,59.6 29.7,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "29.7,59.3 29.3,59.6 29.3,60.5 29.7,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "27.4,60.8 27.1,60.5 26.2,60.5 25.9,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "25.9,60.8 26.2,60.5 26.2,59.6 25.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "25.9,59.3 26.2,59.6 27.1,59.6 27.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "27.4,59.3 27.1,59.6 27.1,60.5 27.4,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "25.2,60.8 24.8,60.5 24,60.5 23.6,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "23.6,60.8 24,60.5 24,59.6 23.6,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "23.6,59.3 24,59.6 24.8,59.6 25.2,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "25.2,59.3 24.8,59.6 24.8,60.5 25.2,60.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7,
    y: 59.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "22.9,60.8 22.6,60.5 21.7,60.5 21.4,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.4,60.8 21.7,60.5 21.7,59.6 21.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "21.4,59.3 21.7,59.6 22.6,59.6 22.9,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.9,59.3 22.6,59.6 22.6,60.5 22.9,60.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_4_"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 57.6, 7.2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -6.2,
    y: -96.7,
    className: "st28",
    width: 18,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "11.5,-94.8 11.2,-95.1 10.3,-95.1 10,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "10,-94.8 10.3,-95.1 10.3,-96 10,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "10,-96.3 10.3,-96 11.2,-96 11.5,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "11.5,-96.3 11.2,-96 11.2,-95.1 11.5,-94.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "9.2,-94.8 8.9,-95.1 8,-95.1 7.7,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "7.7,-94.8 8,-95.1 8,-96 7.7,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "7.7,-96.3 8,-96 8.9,-96 9.2,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "9.2,-96.3 8.9,-96 8.9,-95.1 9.2,-94.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.8,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "7,-94.8 6.7,-95.1 5.8,-95.1 5.5,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "5.5,-94.8 5.8,-95.1 5.8,-96 5.5,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "5.5,-96.3 5.8,-96 6.7,-96 7,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "7,-96.3 6.7,-96 6.7,-95.1 7,-94.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "4.7,-94.8 4.4,-95.1 3.5,-95.1 3.2,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "3.2,-94.8 3.5,-95.1 3.5,-96 3.2,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "3.2,-96.3 3.5,-96 4.4,-96 4.7,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "4.7,-96.3 4.4,-96 4.4,-95.1 4.7,-94.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "2.5,-94.8 2.2,-95.1 1.3,-95.1 1,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "1,-94.8 1.3,-95.1 1.3,-96 1,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "1,-96.3 1.3,-96 2.2,-96 2.5,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "2.5,-96.3 2.2,-96 2.2,-95.1 2.5,-94.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "0.2,-94.8 -0.1,-95.1 -1,-95.1 -1.3,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-1.3,-94.8 -1,-95.1 -1,-96 -1.3,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-1.3,-96.3 -1,-96 -0.1,-96 0.2,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "0.2,-96.3 -0.1,-96 -0.1,-95.1 0.2,-94.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.2,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-2,-94.8 -2.3,-95.1 -3.2,-95.1 -3.5,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-3.5,-94.8 -3.2,-95.1 -3.2,-96 -3.5,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-3.5,-96.3 -3.2,-96 -2.3,-96 -2,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-2,-96.3 -2.3,-96 -2.3,-95.1 -2,-94.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.5,
    y: -96,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-4.3,-94.8 -4.6,-95.1 -5.5,-95.1 -5.8,-94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-5.8,-94.8 -5.5,-95.1 -5.5,-96 -5.8,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-5.8,-96.3 -5.5,-96 -4.6,-96 -4.3,-96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-4.3,-96.3 -4.6,-96 -4.6,-95.1 -4.3,-94.8  "
  }))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "breadboardbreadboard_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 65.6,
    className: "st39",
    width: 40.6,
    height: 31.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 80.3,
    className: "st40",
    width: 28.3,
    height: 2.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sockets"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,78c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,80.3c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,82.5c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,84.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,87c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,82.5c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,84.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,78c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,80.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,82.5c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,84.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,87c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,78c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,80.3c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,82.5c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,84.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,87c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,78c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,80.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,82.5c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,84.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,87c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "A17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,78c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,78c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 78,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "B17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,80.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,80.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 80.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "C17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,82.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,82.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 82.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "D17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,84.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,84.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 84.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "E17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,87c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,87c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 87,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,93.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,96c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,98.3c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,100.5c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J1pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.4,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.9,102.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 57.1,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,93.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,96c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J2pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M58.7,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.1,102.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 59.4,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J3pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.9,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.4,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 61.6,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,93.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,96c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,98.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,100.5c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J4pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M63.2,102.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 63.9,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J5pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.4,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.9,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 66.1,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J6pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.1,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 68.4,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J7pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M69.9,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.4,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 70.6,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J8pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.1,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 72.9,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J9pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M74.4,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 75.1,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,93.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,96c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,98.3c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,100.5c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J10pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.6,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,102.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 77.4,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,93.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,96c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,98.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,100.5c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J11pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M78.9,102.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.4,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 79.6,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J12pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M81.1,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.6,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 81.9,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J13pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.4,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 84.1,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J14pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M85.6,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.1,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 86.4,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J15pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M87.9,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 88.6,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J16pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M90.1,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 90.9,
    cy: 102.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "F17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,93.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,93.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 93.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "G17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,96c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,96c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 96,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "H17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,98.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,98.3c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 98.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "I17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,100.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,100.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 100.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "J17pin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.4,102.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,102.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 93.1,
    cy: 102.8,
    r: 0.4
  }))))))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 54.3,
    cy: 81.4,
    r: 1.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 87,
    cy: 81.4,
    r: 1.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "72.3,65.6 69,65.6 68.7,64.7 72.6,64.7 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "90.9,79.8 90.9,83.1 91.9,83.4 91.9,79.5 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 10.6,
    className: "st32",
    width: 30.6,
    height: 24.4
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M14.4,35V10.6L13,9.2c-0.3,0.3-0.4,0.6-0.4,1v25.2c0,0.4,0.2,0.7,0.4,1L14.4,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M44.9,10.6V35l1.4,1.4c0.3-0.3,0.4-0.6,0.4-1V10.2c0-0.4-0.2-0.7-0.4-1L44.9,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M13,9.2l1.4,1.4h30.6l1.4-1.4c-0.3-0.3-0.6-0.4-1-0.4H14C13.6,8.8,13.2,9,13,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M44.9,35H14.4L13,36.4c0.3,0.3,0.6,0.4,1,0.4h31.4c0.4,0,0.7-0.2,1-0.4L44.9,35z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "LEDM1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "connector3terminal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector2terminal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector1terminal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector0terminal"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st46",
    cx: 29.1,
    cy: 113,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M29,112.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0.1-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0L29,112.2z  M28.6,112c-0.4,0.2-0.6,0.6-0.6,1c0,0.1,0,0.2,0,0.2l0.3-0.1c0,0,0-0.1,0-0.2c0-0.3,0.2-0.6,0.4-0.7L28.6,112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "30.3,112.2 30.3,112.2 30.3,112.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st49",
    cx: 29.2,
    cy: 113,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M29.9,112.2l-0.1,0.4l0.2,0.1l0.2-0.1c0-0.1-0.1-0.2-0.1-0.2C30,112.3,29.9,112.2,29.9,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M28.6,113.4l-0.3,0.3c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1l0.1-0.5 L28.6,113.4z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "LEDM2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "connector3terminal_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector2terminal_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector1terminal_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector0terminal_1_"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st46",
    cx: 38.1,
    cy: 113,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M38,112.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0.1-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0L38,112.2z  M37.6,112c-0.4,0.2-0.6,0.6-0.6,1c0,0.1,0,0.2,0,0.2l0.3-0.1c0,0,0-0.1,0-0.2c0-0.3,0.2-0.6,0.4-0.7L37.6,112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "39.3,112.2 39.3,112.2 39.3,112.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st49",
    cx: 38.2,
    cy: 113,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M38.9,112.2l-0.1,0.4l0.2,0.1l0.2-0.1c0-0.1-0.1-0.2-0.1-0.2C39,112.3,38.9,112.2,38.9,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M37.6,113.4l-0.3,0.3c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1l0.1-0.5 L37.6,113.4z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "RxTx"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "connector3terminal_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector2terminal_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector1terminal_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector0terminal_2_"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st46",
    cx: 47.1,
    cy: 113,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M46.9,112.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0.1-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0L46.9,112.2z  M46.6,112c-0.4,0.2-0.6,0.6-0.6,1c0,0.1,0,0.2,0,0.2l0.3-0.1c0,0,0-0.1,0-0.2c0-0.3,0.2-0.6,0.4-0.7L46.6,112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "48.3,112.2 48.3,112.2 48.3,112.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st49",
    cx: 47.2,
    cy: 113,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M47.9,112.2l-0.1,0.4l0.2,0.1l0.2-0.1c0-0.1-0.1-0.2-0.1-0.2C48,112.3,47.9,112.2,47.9,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M46.6,113.4l-0.3,0.3c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1l0.1-0.5 L46.6,113.4z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "LED13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "connector3terminal_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector2terminal_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector1terminal_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector0terminal_3_"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st52",
    cx: 56.1,
    cy: 113,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M55.9,112.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0.1-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0L55.9,112.2z  M55.6,112c-0.4,0.2-0.6,0.6-0.6,1c0,0.1,0,0.2,0,0.2l0.3-0.1c0,0,0-0.1,0-0.2c0-0.3,0.2-0.6,0.4-0.7L55.6,112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "57.3,112.2 57.3,112.2 57.3,112.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st54",
    cx: 56.2,
    cy: 113,
    r: 0.6
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "LEDBat"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "connector3terminal_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector2terminal_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector1terminal_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector0terminal_4_"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st55",
    cx: 28.9,
    cy: 45.4,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M28.7,44.6c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0.1-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0L28.7,44.6z  M28.4,44.4c-0.4,0.2-0.6,0.6-0.6,1c0,0.1,0,0.2,0,0.2l0.3-0.1c0,0,0-0.1,0-0.2c0-0.3,0.2-0.6,0.4-0.7L28.4,44.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "30.1,44.6 30.1,44.6 30.1,44.6  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 29,
    cy: 45.5,
    r: 0.6
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "LEDPwr"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "connector3terminal_5_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector2terminal_5_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector1terminal_5_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connector0terminal_5_"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st58",
    cx: 22.3,
    cy: 45.4,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M22.1,44.6c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0.1-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0L22.1,44.6z  M21.7,44.4c-0.4,0.2-0.6,0.6-0.6,1c0,0.1,0,0.2,0,0.2l0.3-0.1c0,0,0-0.1,0-0.2c0-0.3,0.2-0.6,0.4-0.7L21.7,44.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "23.5,44.6 23.5,44.6 23.5,44.6  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 22.3,
    cy: 45.5,
    r: 0.6
  })))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st61",
    cx: 62.9,
    cy: 30.2,
    r: 2.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 62.9,
    cy: 30.2,
    r: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 28.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.522 52.5965)",
    className: "st18",
    width: 4.1,
    height: 1.4
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 62.7,
    cy: 29.8,
    r: 2
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st63",
    cx: 61.7,
    cy: 28.9,
    r: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M62.1,29.9h-0.7c0,0-0.1,0-0.1-0.1v-1.9c0,0,0-0.1,0.1-0.1h0.7c0,0,0.1,0,0.1,0.1L62.1,29.9 C62.2,29.9,62.1,29.9,62.1,29.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M76.8,33.7h-2.5c-0.1,0-0.2-0.1-0.2-0.2v-6.7c0-0.1,0-0.1,0.1-0.1h2.5c0.1,0,0.2,0.1,0.2,0.2L76.8,33.7 C76.9,33.7,76.9,33.7,76.8,33.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M76.7,33.6h-2.5c-0.1,0-0.1,0-0.1-0.1v-6.7c0-0.1,0-0.1,0.1-0.1h2.5c0.1,0,0.1,0,0.1,0.1L76.7,33.6 C76.8,33.6,76.8,33.6,76.7,33.6z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "rect27_5_",
    className: "st30",
    points: "75,29.9 75,27.7 76.4,29.1 76.4,31.3 "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "rect51_4_",
    x: 73.2,
    y: 27.7,
    className: "st66",
    width: 1.8,
    height: 2.2
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "76.4,31.3 74.6,31.3 73.2,29.9 75,29.9 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M76.2,29c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0-0.2,0l-1-1C75.1,28.1,75,28,75,27.9c0-0.1,0.1,0,0.2,0L76.2,29z "
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 27.8,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 28,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 28.1,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 28.3,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 28.5,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 28.6,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 28.8,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 29,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 29.1,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 29.3,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 29.5,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 29.6,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 29.8,
    className: "st69",
    width: 1.6,
    height: 0
  })))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st70",
    cx: 87.6,
    cy: 30.2,
    r: 2.7
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st71",
    cx: 87.6,
    cy: 30.2,
    r: 2.7
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st72",
    cx: 87.9,
    cy: 30.4,
    r: 2.4
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 87.6,
    cy: 30.3,
    r: 2.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M86.7,28.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.4,0.3-0.6,0.7-0.8,1.2l0.1,0.1c0.1-0.5,0.4-0.9,0.9-1.3 C86.5,28.3,86.6,28.3,86.7,28.1L86.7,28.1z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st61",
    cx: 62.9,
    cy: 45.4,
    r: 2.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 62.9,
    cy: 45.4,
    r: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 43.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.2585 57.0437)",
    className: "st18",
    width: 4.1,
    height: 1.4
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 62.7,
    cy: 45,
    r: 2
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st63",
    cx: 61.7,
    cy: 44,
    r: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M62.1,45.1h-0.7c0,0-0.1,0-0.1-0.1v-1.9c0,0,0-0.1,0.1-0.1h0.7c0,0,0.1,0,0.1,0.1L62.1,45.1 C62.2,45,62.1,45.1,62.1,45.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M76.8,48.9h-2.5c-0.1,0-0.2-0.1-0.2-0.2V42c0-0.1,0-0.1,0.1-0.1h2.5c0.1,0,0.2,0.1,0.2,0.2L76.8,48.9 C76.9,48.9,76.9,48.9,76.8,48.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M76.7,48.8h-2.5c-0.1,0-0.1,0-0.1-0.1V42c0-0.1,0-0.1,0.1-0.1h2.5c0.1,0,0.1,0,0.1,0.1L76.7,48.8 C76.8,48.8,76.8,48.8,76.7,48.8z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: "rect27_1_",
    className: "st30",
    points: "75,45.1 75,42.9 76.4,44.3 76.4,46.5 "
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "rect51_1_",
    x: 73.2,
    y: 42.9,
    className: "st66",
    width: 1.8,
    height: 2.2
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "76.4,46.5 74.6,46.5 73.2,45.1 75,45.1 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M76.2,44.2c0.1,0.1,0.2,0.2,0.2,0.3s-0.1,0-0.2,0l-1-1c-0.1-0.1-0.2-0.2-0.2-0.3s0.1,0,0.2,0L76.2,44.2z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 43,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 43.1,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 43.3,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 43.5,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 43.6,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 43.8,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 44,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 44.1,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 44.3,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 44.5,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 44.6,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 44.8,
    className: "st69",
    width: 1.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 45,
    className: "st69",
    width: 1.6,
    height: 0
  })))), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "st70",
    cx: 87.6,
    cy: 45.4,
    r: 2.7
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "st71",
    cx: 87.6,
    cy: 45.4,
    r: 2.7
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "st72",
    cx: 87.9,
    cy: 45.6,
    r: 2.4
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 87.6,
    cy: 45.4,
    r: 2.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M86.7,43.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.4,0.3-0.6,0.7-0.8,1.2l0.1,0.1c0.1-0.5,0.4-0.9,0.9-1.3 C86.5,43.5,86.6,43.4,86.7,43.3L86.7,43.3z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "st70",
    cx: 35.5,
    cy: 45.4,
    r: 1.5
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "st75",
    cx: 35.5,
    cy: 45.4,
    r: 1.5
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "st72",
    cx: 35.7,
    cy: 45.5,
    r: 1.3
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "st76",
    cx: 35.5,
    cy: 45.4,
    r: 1.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M35,44.3c-0.1,0-0.2,0.1-0.3,0.2c-0.2,0.2-0.4,0.4-0.4,0.7l0,0.1c0.1-0.3,0.2-0.5,0.5-0.7 C34.9,44.4,35,44.3,35,44.3L35,44.3z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_WaySurface"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st78",
    cx: 62.9,
    cy: 15.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M62.8,11.9c-1.9,0-3.5,1.6-3.5,3.5C59.6,13.6,61,12.2,62.8,11.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st80",
    cx: 62.9,
    cy: 15.5,
    r: 2
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_WayNav"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st81",
    cx: 62.9,
    cy: 15.7,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M61.5,15.8c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-0.1c0,0.7-0.6,1.3-1.3,1.3 C62.1,17.1,61.5,16.5,61.5,15.8L61.5,15.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 62.9,
    cy: 15.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st83",
    cx: 62.9,
    cy: 15.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st84",
    cx: 62.7,
    cy: 15.3,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M61.9,15.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1v0c0,0.6-0.5,1-1,1C62.3,16.4,61.9,16,61.9,15.5L61.9,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M63.7,15.3c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1l0,0c0,0.6,0.5,1,1,1C63.2,16.3,63.7,15.8,63.7,15.3L63.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M61.7,15.3c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v0c0-0.6-0.5-1-1-1C62.1,14.3,61.7,14.7,61.7,15.3L61.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M63.3,15.7c0,0.1-0.1,0.2-0.2,0.2h-0.8c-0.1,0-0.2-0.1-0.2-0.2v-0.8c0-0.1,0.1-0.2,0.2-0.2h0.8 c0.1,0,0.2,0.1,0.2,0.2V15.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 14.1,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 116.6424 -18.7118)",
    className: "st83",
    width: 1.6,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M62.3,14.7c0,0.1-0.1,0.2-0.2,0.2h-0.8c-0.1,0-0.2-0.1-0.2-0.2v-0.8c0-0.1,0.1-0.2,0.2-0.2h0.8 c0.1,0,0.2,0.1,0.2,0.2V14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M61.3,14.9c-0.1,0-0.2-0.1-0.2-0.2v-0.8c0-0.1,0.1-0.2,0.2-0.2h0.8c0.1,0,0.2,0.1,0.2,0.2l0,0 c0-0.1-0.1-0.2-0.2-0.2h-0.8c-0.1,0-0.2,0.1-0.2,0.2v0.8C61.1,14.8,61.2,14.9,61.3,14.9L61.3,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M62.1,13.7c0.1,0,0.2,0.1,0.2,0.2l0,0.8c0,0.1-0.1,0.2-0.2,0.2l-0.8,0c-0.1,0-0.2-0.1-0.2-0.2l0,0 c0,0.1,0.1,0.2,0.2,0.2l0.8,0c0.1,0,0.2-0.1,0.2-0.2l0-0.8C62.3,13.8,62.2,13.7,62.1,13.7L62.1,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M63.1,14.6c0.1,0,0.2,0.1,0.2,0.2l0,0.8c0,0.1-0.1,0.2-0.2,0.2l-0.8,0c-0.1,0-0.2-0.1-0.2-0.2l0,0 c0,0.1,0.1,0.2,0.2,0.2l0.8,0c0.1,0,0.2-0.1,0.2-0.2l0-0.8C63.3,14.7,63.2,14.6,63.1,14.6L63.1,14.6z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "connector615pin",
    className: "st87",
    cx: 41.5,
    cy: 79.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector613pin_1_",
    className: "st87",
    cx: 41.2,
    cy: 77.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector614pin",
    className: "st87",
    cx: 41.5,
    cy: 75.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector185pin_2_",
    className: "st87",
    cx: 41.2,
    cy: 74.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector186pin_2_",
    className: "st87",
    cx: 41.5,
    cy: 72.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector187pin_2_",
    className: "st87",
    cx: 41.2,
    cy: 70.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector188pin_2_",
    className: "st87",
    cx: 41.5,
    cy: 68.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector189pin_2_",
    className: "st87",
    cx: 41.2,
    cy: 67,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector190pin_2_",
    className: "st87",
    cx: 41.5,
    cy: 65.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector616pin",
    className: "st87",
    cx: 41.2,
    cy: 63.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4,
    y: 62.3,
    className: "st28",
    width: 1.9,
    height: 18.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 79.2,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,80.1 41,79.9 41,79.2 40.7,78.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,78.9 41,79.2 41.7,79.2 42,78.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,78.9 41.7,79.2 41.7,79.9 42,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,80.1 41.7,79.9 41,79.9 40.7,80.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 77.4,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,78.3 41,78.1 41,77.4 40.7,77.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,77.1 41,77.4 41.7,77.4 42,77.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,77.1 41.7,77.4 41.7,78.1 42,78.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,78.3 41.7,78.1 41,78.1 40.7,78.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 75.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,76.5 41,76.2 41,75.5 40.7,75.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,75.3 41,75.5 41.7,75.5 42,75.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,75.3 41.7,75.5 41.7,76.2 42,76.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,76.5 41.7,76.2 41,76.2 40.7,76.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 73.7,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,74.7 41,74.4 41,73.7 40.7,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,73.5 41,73.7 41.7,73.7 42,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,73.5 41.7,73.7 41.7,74.4 42,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,74.7 41.7,74.4 41,74.4 40.7,74.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 71.9,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,72.9 41,72.6 41,71.9 40.7,71.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,71.7 41,71.9 41.7,71.9 42,71.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,71.7 41.7,71.9 41.7,72.6 42,72.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,72.9 41.7,72.6 41,72.6 40.7,72.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 70.1,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,71.1 41,70.8 41,70.1 40.7,69.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,69.9 41,70.1 41.7,70.1 42,69.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,69.9 41.7,70.1 41.7,70.8 42,71.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,71.1 41.7,70.8 41,70.8 40.7,71.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 68.3,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,69.3 41,69 41,68.3 40.7,68.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,68.1 41,68.3 41.7,68.3 42,68.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,68.1 41.7,68.3 41.7,69 42,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,69.3 41.7,69 41,69 40.7,69.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 66.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,67.5 41,67.2 41,66.5 40.7,66.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,66.2 41,66.5 41.7,66.5 42,66.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,66.2 41.7,66.5 41.7,67.2 42,67.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,67.5 41.7,67.2 41,67.2 40.7,67.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 64.7,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,65.6 41,65.4 41,64.7 40.7,64.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,64.4 41,64.7 41.7,64.7 42,64.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,64.4 41.7,64.7 41.7,65.4 42,65.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,65.6 41.7,65.4 41,65.4 40.7,65.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 62.9,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "40.7,63.8 41,63.6 41,62.9 40.7,62.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "40.7,62.6 41,62.9 41.7,62.9 42,62.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "42,62.6 41.7,62.9 41.7,63.6 42,63.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "42,63.8 41.7,63.6 41,63.6 40.7,63.8  "
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "connector192pin_2_",
    className: "st87",
    cx: 21.7,
    cy: 63.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector193pin_2_",
    className: "st87",
    cx: 22,
    cy: 65.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector194pin_2_",
    className: "st87",
    cx: 21.7,
    cy: 67,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector195pin_2_",
    className: "st87",
    cx: 22,
    cy: 68.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector196pin_2_",
    className: "st87",
    cx: 21.7,
    cy: 70.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector197pin_2_",
    className: "st87",
    cx: 22,
    cy: 72.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector198pin_2_",
    className: "st87",
    cx: 21.7,
    cy: 74.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector199pin_2_",
    className: "st87",
    cx: 22,
    cy: 75.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector200pin_2_",
    className: "st87",
    cx: 21.7,
    cy: 77.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector201pin_2_",
    className: "st87",
    cx: 22,
    cy: 79.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 62.3,
    className: "st28",
    width: 1.9,
    height: 18.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 79.2,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,80.1 21.5,79.9 21.5,79.2 21.3,78.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,78.9 21.5,79.2 22.3,79.2 22.5,78.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,78.9 22.3,79.2 22.3,79.9 22.5,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,80.1 22.3,79.9 21.5,79.9 21.3,80.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 77.4,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,78.3 21.5,78.1 21.5,77.4 21.3,77.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,77.1 21.5,77.4 22.3,77.4 22.5,77.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,77.1 22.3,77.4 22.3,78.1 22.5,78.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,78.3 22.3,78.1 21.5,78.1 21.3,78.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 75.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,76.5 21.5,76.2 21.5,75.5 21.3,75.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,75.3 21.5,75.5 22.3,75.5 22.5,75.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,75.3 22.3,75.5 22.3,76.2 22.5,76.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,76.5 22.3,76.2 21.5,76.2 21.3,76.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 73.7,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,74.7 21.5,74.4 21.5,73.7 21.3,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,73.5 21.5,73.7 22.3,73.7 22.5,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,73.5 22.3,73.7 22.3,74.4 22.5,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,74.7 22.3,74.4 21.5,74.4 21.3,74.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 71.9,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,72.9 21.5,72.6 21.5,71.9 21.3,71.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,71.7 21.5,71.9 22.3,71.9 22.5,71.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,71.7 22.3,71.9 22.3,72.6 22.5,72.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,72.9 22.3,72.6 21.5,72.6 21.3,72.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 70.1,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,71.1 21.5,70.8 21.5,70.1 21.3,69.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,69.9 21.5,70.1 22.3,70.1 22.5,69.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,69.9 22.3,70.1 22.3,70.8 22.5,71.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,71.1 22.3,70.8 21.5,70.8 21.3,71.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 68.3,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,69.3 21.5,69 21.5,68.3 21.3,68.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,68.1 21.5,68.3 22.3,68.3 22.5,68.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,68.1 22.3,68.3 22.3,69 22.5,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,69.3 22.3,69 21.5,69 21.3,69.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 66.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,67.5 21.5,67.2 21.5,66.5 21.3,66.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,66.2 21.5,66.5 22.3,66.5 22.5,66.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,66.2 22.3,66.5 22.3,67.2 22.5,67.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,67.5 22.3,67.2 21.5,67.2 21.3,67.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 64.7,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,65.6 21.5,65.4 21.5,64.7 21.3,64.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,64.4 21.5,64.7 22.3,64.7 22.5,64.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,64.4 22.3,64.7 22.3,65.4 22.5,65.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,65.6 22.3,65.4 21.5,65.4 21.3,65.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 62.9,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "21.3,63.8 21.5,63.6 21.5,62.9 21.3,62.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "21.3,62.6 21.5,62.9 22.3,62.9 22.5,62.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "22.5,62.6 22.3,62.9 22.3,63.6 22.5,63.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "22.5,63.8 22.3,63.6 21.5,63.6 21.3,63.8  "
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "connector624pin",
    className: "st87",
    cx: 25.2,
    cy: 64.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector625pin",
    className: "st87",
    cx: 25.5,
    cy: 66.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector196pin_1_",
    className: "st87",
    cx: 25.2,
    cy: 68.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector626pin",
    className: "st87",
    cx: 25.5,
    cy: 70.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector198pin_1_",
    className: "st87",
    cx: 25.2,
    cy: 72,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector199pin_1_",
    className: "st87",
    cx: 25.5,
    cy: 73.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector627pin",
    className: "st87",
    cx: 25.2,
    cy: 75.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector628pin",
    className: "st87",
    cx: 25.5,
    cy: 77.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 63.9,
    className: "st28",
    width: 1.9,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 77.1,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,78.1 25.1,77.8 25.1,77.1 24.8,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,76.9 25.1,77.1 25.8,77.1 26.1,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,76.9 25.8,77.1 25.8,77.8 26.1,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,78.1 25.8,77.8 25.1,77.8 24.8,78.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 75.3,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,76.3 25.1,76 25.1,75.3 24.8,75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,75 25.1,75.3 25.8,75.3 26.1,75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,75.1 25.8,75.3 25.8,76 26.1,76.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,76.3 25.8,76 25.1,76 24.8,76.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 73.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,74.5 25.1,74.2 25.1,73.5 24.8,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,73.2 25.1,73.5 25.8,73.5 26.1,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,73.2 25.8,73.5 25.8,74.2 26.1,74.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,74.5 25.8,74.2 25.1,74.2 24.8,74.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 71.7,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,72.6 25.1,72.4 25.1,71.7 24.8,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,71.4 25.1,71.7 25.8,71.7 26.1,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,71.4 25.8,71.7 25.8,72.4 26.1,72.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,72.6 25.8,72.4 25.1,72.4 24.8,72.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 69.9,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,70.8 25.1,70.6 25.1,69.9 24.8,69.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,69.6 25.1,69.9 25.8,69.9 26.1,69.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,69.6 25.8,69.9 25.8,70.6 26.1,70.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,70.8 25.8,70.6 25.1,70.6 24.8,70.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 68.1,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,69 25.1,68.8 25.1,68.1 24.8,67.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,67.8 25.1,68.1 25.8,68.1 26.1,67.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,67.8 25.8,68.1 25.8,68.8 26.1,69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,69 25.8,68.8 25.1,68.8 24.8,69  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 66.3,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,67.2 25.1,67 25.1,66.3 24.8,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,66 25.1,66.3 25.8,66.3 26.1,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,66 25.8,66.3 25.8,67 26.1,67.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,67.2 25.8,67 25.1,67 24.8,67.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 64.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.8,65.4 25.1,65.2 25.1,64.5 24.8,64.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "24.8,64.2 25.1,64.5 25.8,64.5 26.1,64.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "26.1,64.2 25.8,64.5 25.8,65.2 26.1,65.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "26.1,65.4 25.8,65.2 25.1,65.2 24.8,65.4  "
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "connector623pin",
    className: "st87",
    cx: 37.6,
    cy: 64.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector195pin_3_",
    className: "st87",
    cx: 37.9,
    cy: 66.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector196pin_3_",
    className: "st87",
    cx: 37.6,
    cy: 68.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector197pin_3_",
    className: "st87",
    cx: 37.9,
    cy: 70.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector198pin_3_",
    className: "st87",
    cx: 37.6,
    cy: 72,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector622pin",
    className: "st87",
    cx: 37.9,
    cy: 73.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector200pin_3_",
    className: "st87",
    cx: 37.6,
    cy: 75.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector621pin",
    className: "st87",
    cx: 37.9,
    cy: 77.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 63.9,
    className: "st28",
    width: 1.9,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 77.1,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,78.1 37.5,77.8 37.5,77.1 37.2,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,76.9 37.5,77.1 38.2,77.1 38.5,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,76.9 38.2,77.1 38.2,77.8 38.5,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,78.1 38.2,77.8 37.5,77.8 37.2,78.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 75.3,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,76.3 37.5,76 37.5,75.3 37.2,75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,75 37.5,75.3 38.2,75.3 38.5,75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,75.1 38.2,75.3 38.2,76 38.5,76.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,76.3 38.2,76 37.5,76 37.2,76.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 73.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,74.5 37.5,74.2 37.5,73.5 37.2,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,73.2 37.5,73.5 38.2,73.5 38.5,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,73.2 38.2,73.5 38.2,74.2 38.5,74.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,74.5 38.2,74.2 37.5,74.2 37.2,74.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 71.7,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,72.6 37.5,72.4 37.5,71.7 37.2,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,71.4 37.5,71.7 38.2,71.7 38.5,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,71.4 38.2,71.7 38.2,72.4 38.5,72.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,72.6 38.2,72.4 37.5,72.4 37.2,72.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 69.9,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,70.8 37.5,70.6 37.5,69.9 37.2,69.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,69.6 37.5,69.9 38.2,69.9 38.5,69.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,69.6 38.2,69.9 38.2,70.6 38.5,70.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,70.8 38.2,70.6 37.5,70.6 37.2,70.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 68.1,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,69 37.5,68.8 37.5,68.1 37.2,67.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,67.8 37.5,68.1 38.2,68.1 38.5,67.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,67.8 38.2,68.1 38.2,68.8 38.5,69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,69 38.2,68.8 37.5,68.8 37.2,69  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 66.3,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,67.2 37.5,67 37.5,66.3 37.2,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,66 37.5,66.3 38.2,66.3 38.5,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,66 38.2,66.3 38.2,67 38.5,67.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,67.2 38.2,67 37.5,67 37.2,67.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 64.5,
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "37.2,65.4 37.5,65.2 37.5,64.5 37.2,64.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "37.2,64.2 37.5,64.5 38.2,64.5 38.5,64.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "38.5,64.2 38.2,64.5 38.2,65.2 38.5,65.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "38.5,65.4 38.2,65.2 37.5,65.2 37.2,65.4  "
  }))), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "connector651pin",
    className: "st33",
    cx: 12.8,
    cy: 58.6,
    r: 0.6
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "connector652pin",
    className: "st33",
    cx: 15,
    cy: 58.6,
    r: 0.6
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "connector653pin",
    className: "st33",
    cx: 17.3,
    cy: 58.6,
    r: 0.6
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "connector654pin",
    className: "st33",
    cx: 12.8,
    cy: 60.9,
    r: 0.6
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "connector655pin",
    className: "st33",
    cx: 15,
    cy: 60.9,
    r: 0.6
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "connector656pin",
    className: "st33",
    cx: 17.3,
    cy: 60.9,
    r: 0.6
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_23_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -211.5,
    y: -80.6,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -206.3,
    y: -80,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-205.1,-78.8 -205.4,-79.1 -206.3,-79.1 -206.6,-78.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-206.6,-78.8 -206.3,-79.1 -206.3,-80 -206.6,-80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-206.6,-80.3 -206.3,-80 -205.4,-80 -205.1,-80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-205.1,-80.3 -205.4,-80 -205.4,-79.1 -205.1,-78.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -80,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-207.4,-78.8 -207.7,-79.1 -208.6,-79.1 -208.9,-78.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-208.9,-78.8 -208.6,-79.1 -208.6,-80 -208.9,-80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-208.9,-80.3 -208.6,-80 -207.7,-80 -207.4,-80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-207.4,-80.3 -207.7,-80 -207.7,-79.1 -207.4,-78.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -210.8,
    y: -80,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-209.6,-78.8 -209.9,-79.1 -210.8,-79.1 -211.1,-78.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-211.1,-78.8 -210.8,-79.1 -210.8,-80 -211.1,-80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-211.1,-80.3 -210.8,-80 -209.9,-80 -209.6,-80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-209.6,-80.3 -209.9,-80 -209.9,-79.1 -209.6,-78.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_24_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 57.5,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 58.2,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "18,59.4 17.7,59 16.8,59 16.5,59.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "16.5,59.4 16.8,59 16.8,58.2 16.5,57.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "16.5,57.8 16.8,58.2 17.7,58.2 18,57.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "18,57.8 17.7,58.2 17.7,59 18,59.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 58.2,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "15.8,59.4 15.5,59 14.6,59 14.3,59.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "14.3,59.4 14.6,59 14.6,58.2 14.3,57.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "14.3,57.8 14.6,58.2 15.5,58.2 15.8,57.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "15.8,57.8 15.5,58.2 15.5,59 15.8,59.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 58.2,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "13.5,59.4 13.2,59 12.3,59 12,59.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "12,59.4 12.3,59 12.3,58.2 12,57.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "12,57.8 12.3,58.2 13.2,58.2 13.5,57.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "13.5,57.8 13.2,58.2 13.2,59 13.5,59.4  "
  })))), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "connector601pin",
    className: "st33",
    cx: 12.7,
    cy: 104.9,
    r: 0.6
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "connector602pin",
    className: "st33",
    cx: 15,
    cy: 104.9,
    r: 0.6
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "connector603pin",
    className: "st33",
    cx: 17.2,
    cy: 104.9,
    r: 0.6
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "connector607pin",
    className: "st33",
    cx: 12.7,
    cy: 107.1,
    r: 0.6
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "connector608pin",
    className: "st33",
    cx: 15,
    cy: 107.1,
    r: 0.6
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "connector609pin",
    className: "st33",
    cx: 17.2,
    cy: 107.1,
    r: 0.6
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "connector604pin",
    className: "st33",
    cx: 19.5,
    cy: 104.9,
    r: 0.6
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "connector605pin",
    className: "st33",
    cx: 21.7,
    cy: 104.9,
    r: 0.6
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "connector606pin",
    className: "st33",
    cx: 24,
    cy: 104.9,
    r: 0.6
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    id: "connector610pin",
    className: "st33",
    cx: 19.5,
    cy: 107.1,
    r: 0.6
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    id: "connector611pin",
    className: "st33",
    cx: 21.7,
    cy: 107.1,
    r: 0.6
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    id: "connector612pin",
    className: "st33",
    cx: 24,
    cy: 107.1,
    r: 0.6
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_22_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -211.6,
    y: -36.6,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -206.4,
    y: -36,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-205.2,-34.8 -205.5,-35.1 -206.4,-35.1 -206.7,-34.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-206.7,-34.8 -206.4,-35.1 -206.4,-36 -206.7,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-206.7,-36.3 -206.4,-36 -205.5,-36 -205.2,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-205.2,-36.3 -205.5,-36 -205.5,-35.1 -205.2,-34.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -36,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-207.4,-34.8 -207.8,-35.1 -208.6,-35.1 -208.9,-34.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-208.9,-34.8 -208.6,-35.1 -208.6,-36 -208.9,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-208.9,-36.3 -208.6,-36 -207.8,-36 -207.4,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-207.4,-36.3 -207.8,-36 -207.8,-35.1 -207.4,-34.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -210.9,
    y: -36,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-209.7,-34.8 -210,-35.1 -210.9,-35.1 -211.2,-34.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-211.2,-34.8 -210.9,-35.1 -210.9,-36 -211.2,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-211.2,-36.3 -210.9,-36 -210,-36 -209.7,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-209.7,-36.3 -210,-36 -210,-35.1 -209.7,-34.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_21_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -211.6,
    y: -34.4,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -206.4,
    y: -33.7,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-205.2,-32.5 -205.5,-32.9 -206.4,-32.9 -206.7,-32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-206.7,-32.5 -206.4,-32.9 -206.4,-33.7 -206.7,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-206.7,-34.1 -206.4,-33.7 -205.5,-33.7 -205.2,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-205.2,-34.1 -205.5,-33.7 -205.5,-32.9 -205.2,-32.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -33.7,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-207.4,-32.5 -207.8,-32.9 -208.6,-32.9 -208.9,-32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-208.9,-32.5 -208.6,-32.9 -208.6,-33.7 -208.9,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-208.9,-34.1 -208.6,-33.7 -207.8,-33.7 -207.4,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-207.4,-34.1 -207.8,-33.7 -207.8,-32.9 -207.4,-32.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -210.9,
    y: -33.7,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-209.7,-32.5 -210,-32.9 -210.9,-32.9 -211.2,-32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-211.2,-32.5 -210.9,-32.9 -210.9,-33.7 -211.2,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-211.2,-34.1 -210.9,-33.7 -210,-33.7 -209.7,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-209.7,-34.1 -210,-33.7 -210,-32.9 -209.7,-32.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_26_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -204.8,
    y: -36.6,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -199.6,
    y: -36,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-198.4,-34.8 -198.8,-35.1 -199.6,-35.1 -199.9,-34.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-199.9,-34.8 -199.6,-35.1 -199.6,-36 -199.9,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-199.9,-36.3 -199.6,-36 -198.8,-36 -198.4,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-198.4,-36.3 -198.8,-36 -198.8,-35.1 -198.4,-34.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -201.9,
    y: -36,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-200.7,-34.8 -201,-35.1 -201.9,-35.1 -202.2,-34.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-202.2,-34.8 -201.9,-35.1 -201.9,-36 -202.2,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-202.2,-36.3 -201.9,-36 -201,-36 -200.7,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-200.7,-36.3 -201,-36 -201,-35.1 -200.7,-34.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -204.1,
    y: -36,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-202.9,-34.8 -203.3,-35.1 -204.1,-35.1 -204.4,-34.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-204.4,-34.8 -204.1,-35.1 -204.1,-36 -204.4,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-204.4,-36.3 -204.1,-36 -203.3,-36 -202.9,-36.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-202.9,-36.3 -203.3,-36 -203.3,-35.1 -202.9,-34.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_25_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -204.8,
    y: -34.4,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -199.6,
    y: -33.7,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-198.4,-32.5 -198.8,-32.9 -199.6,-32.9 -199.9,-32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-199.9,-32.5 -199.6,-32.9 -199.6,-33.7 -199.9,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-199.9,-34.1 -199.6,-33.7 -198.8,-33.7 -198.4,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-198.4,-34.1 -198.8,-33.7 -198.8,-32.9 -198.4,-32.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -201.9,
    y: -33.7,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-200.7,-32.5 -201,-32.9 -201.9,-32.9 -202.2,-32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-202.2,-32.5 -201.9,-32.9 -201.9,-33.7 -202.2,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-202.2,-34.1 -201.9,-33.7 -201,-33.7 -200.7,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-200.7,-34.1 -201,-33.7 -201,-32.9 -200.7,-32.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -204.1,
    y: -33.7,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-202.9,-32.5 -203.3,-32.9 -204.1,-32.9 -204.4,-32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-204.4,-32.5 -204.1,-32.9 -204.1,-33.7 -204.4,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-204.4,-34.1 -204.1,-33.7 -203.3,-33.7 -202.9,-34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-202.9,-34.1 -203.3,-33.7 -203.3,-32.9 -202.9,-32.5  "
  })))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "HC05"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "connector618pin",
    className: "st33",
    cx: 34.3,
    cy: 88.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector617pin",
    className: "st33",
    cx: 32.1,
    cy: 88.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector349pin_9_",
    className: "st33",
    cx: 29.8,
    cy: 88.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector345pin_8_",
    className: "st33",
    cx: 41.1,
    cy: 88.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector619pin",
    className: "st33",
    cx: 38.8,
    cy: 88.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector620pin_1_",
    className: "st33",
    cx: 36.6,
    cy: 88.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_28_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -194.4,
    y: -53.2,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -189.2,
    y: -52.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-188.1,-51.4 -188.4,-51.7 -189.2,-51.7 -189.6,-51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-189.6,-51.4 -189.2,-51.7 -189.2,-52.5 -189.6,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-189.6,-52.9 -189.2,-52.5 -188.4,-52.5 -188.1,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-188.1,-52.9 -188.4,-52.5 -188.4,-51.7 -188.1,-51.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -191.5,
    y: -52.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-190.3,-51.4 -190.6,-51.7 -191.5,-51.7 -191.8,-51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-191.8,-51.4 -191.5,-51.7 -191.5,-52.5 -191.8,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-191.8,-52.9 -191.5,-52.5 -190.6,-52.5 -190.3,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-190.3,-52.9 -190.6,-52.5 -190.6,-51.7 -190.3,-51.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -193.7,
    y: -52.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-192.6,-51.4 -192.9,-51.7 -193.7,-51.7 -194.1,-51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-194.1,-51.4 -193.7,-51.7 -193.7,-52.5 -194.1,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-194.1,-52.9 -193.7,-52.5 -192.9,-52.5 -192.6,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-192.6,-52.9 -192.9,-52.5 -192.9,-51.7 -192.6,-51.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223.16, 140.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_27_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -187.7,
    y: -53.2,
    className: "st28",
    width: 6.7,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -182.5,
    y: -52.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-181.3,-51.4 -181.6,-51.7 -182.5,-51.7 -182.8,-51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-182.8,-51.4 -182.5,-51.7 -182.5,-52.5 -182.8,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-182.8,-52.9 -182.5,-52.5 -181.6,-52.5 -181.3,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-181.3,-52.9 -181.6,-52.5 -181.6,-51.7 -181.3,-51.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -184.7,
    y: -52.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-183.6,-51.4 -183.9,-51.7 -184.7,-51.7 -185.1,-51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-185.1,-51.4 -184.7,-51.7 -184.7,-52.5 -185.1,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-185.1,-52.9 -184.7,-52.5 -183.9,-52.5 -183.6,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-183.6,-52.9 -183.9,-52.5 -183.9,-51.7 -183.6,-51.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -187,
    y: -52.6,
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "-185.8,-51.4 -186.1,-51.7 -187,-51.7 -187.3,-51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-187.3,-51.4 -187,-51.7 -187,-52.5 -187.3,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "-187.3,-52.9 -187,-52.5 -186.1,-52.5 -185.8,-52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "-185.8,-52.9 -186.1,-52.5 -186.1,-51.7 -185.8,-51.4  "
  })))))), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    id: "connector361pin_3_",
    className: "st33",
    cx: 24.4,
    cy: 88.3,
    r: 0.6
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    id: "connector361pin_4_",
    className: "st33",
    cx: 26.7,
    cy: 88.3,
    r: 0.6
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    id: "connector362pin_3_",
    className: "st33",
    cx: 22.2,
    cy: 88.3,
    r: 0.6
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "23.3,87.6 22.8,87.2 22.8,87.2 21.6,87.2 21.6,87.2 21.1,87.6 21.1,88.9 21.6,89.4 21.6,89.4  22.8,89.4 22.8,89.4 23.3,88.9  "
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "25.6,87.6 25.1,87.2 25.1,87.2 23.8,87.2 23.8,87.2 23.3,87.6 23.3,88.9 23.8,89.4 23.8,89.4  25.1,89.4 25.1,89.4 25.6,88.9  "
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "27.8,87.6 27.3,87.2 27.3,87.2 26.1,87.2 26.1,87.2 25.6,87.6 25.6,88.9 26.1,89.4 26.1,89.4  27.3,89.4 27.3,89.4 27.8,88.9  "
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -7.1944, 14.4118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -74,
    y: 29.2,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -103.2367 -44.4247)",
    className: "st35",
    width: 0.4,
    height: 0.4
  }))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "22.6,88.6 22.4,88.4 22,88.4 21.8,88.6 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "22,88.1 22,88.4 21.8,88.6 21.8,87.9 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "22.4,88.1 22,88.1 21.8,87.9 22.6,87.9 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "22.6,88.6 22.4,88.4 22.4,88.1 22.6,87.9 "
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0072, 7.2131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81.2,
    y: 24.3,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -105.4831 -56.5746)",
    className: "st35",
    width: 0.4,
    height: 0.4
  }))), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "24.8,88.6 24.6,88.4 24.3,88.4 24.1,88.6 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "24.3,88.1 24.3,88.4 24.1,88.6 24.1,87.9 "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "24.6,88.1 24.3,88.1 24.1,87.9 24.8,87.9 "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "24.8,88.6 24.6,88.4 24.6,88.1 24.8,87.9 "
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0072, 7.2131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81.2,
    y: 26.5,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -107.7322 -54.3251)",
    className: "st35",
    width: 0.4,
    height: 0.4
  }))), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "27.1,88.6 26.9,88.4 26.5,88.4 26.3,88.6 "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "26.5,88.1 26.5,88.4 26.3,88.6 26.3,87.9 "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "26.9,88.1 26.5,88.1 26.3,87.9 27.1,87.9 "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "27.1,88.6 26.9,88.4 26.9,88.1 27.1,87.9 "
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Jumper"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 87.2,
    className: "st88",
    width: 4.3,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 88.6,
    className: "st89",
    width: 3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 87.4,
    className: "st89",
    width: 0.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 87.7,
    className: "st89",
    width: 0.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 87.4,
    className: "st89",
    width: 0.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 87.7,
    className: "st89",
    width: 0.5,
    height: 1.5
  }))), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    id: "connector361pin_6_",
    className: "st33",
    cx: 91.8,
    cy: 102.8,
    r: 0.6
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    id: "connector361pin_5_",
    className: "st33",
    cx: 94.1,
    cy: 102.8,
    r: 0.6
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    id: "connector362pin_4_",
    className: "st33",
    cx: 89.6,
    cy: 102.8,
    r: 0.6
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "90.7,102.1 90.2,101.7 90.2,101.7 89,101.7 88.9,101.7 88.5,102.1 88.5,103.4 88.9,103.9 89,103.9  90.2,103.9 90.2,103.9 90.7,103.4  "
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "93,102.1 92.5,101.7 92.4,101.7 91.2,101.7 91.2,101.7 90.7,102.1 90.7,103.4 91.2,103.9 91.2,103.9  92.4,103.9 92.5,103.9 93,103.4  "
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "95.2,102.1 94.7,101.7 94.7,101.7 93.5,101.7 93.4,101.7 93,102.1 93,103.4 93.4,103.9 93.5,103.9  94.7,103.9 94.7,103.9 95.2,103.4  "
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -7.1944, 14.4118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -88.5,
    y: 96.6,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -185.1404 8.4539)",
    className: "st35",
    width: 0.4,
    height: 0.4
  }))), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "89.9,103.1 89.8,102.9 89.4,102.9 89.2,103.1 "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "89.4,102.6 89.4,102.9 89.2,103.1 89.2,102.4 "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "89.8,102.6 89.4,102.6 89.2,102.4 89.9,102.4 "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "89.9,103.1 89.8,102.9 89.8,102.6 89.9,102.4 "
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0072, 7.2131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -95.7,
    y: 91.7,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -187.3868 -3.6961)",
    className: "st35",
    width: 0.4,
    height: 0.4
  }))), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "92.2,103.1 92,102.9 91.7,102.9 91.5,103.1 "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "91.7,102.6 91.7,102.9 91.5,103.1 91.5,102.4 "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "92,102.6 91.7,102.6 91.5,102.4 92.2,102.4 "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "92.2,103.1 92,102.9 92,102.6 92.2,102.4 "
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 0.0072, 7.2131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -95.7,
    y: 93.9,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -189.6359 -1.4465)",
    className: "st35",
    width: 0.4,
    height: 0.4
  }))), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "94.4,103.1 94.3,102.9 93.9,102.9 93.7,103.1 "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "93.9,102.6 93.9,102.9 93.7,103.1 93.7,102.4 "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "94.3,102.6 93.9,102.6 93.7,102.4 94.4,102.4 "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "94.4,103.1 94.3,102.9 94.3,102.6 94.4,102.4 "
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Jumper_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.8,
    y: 101.8,
    className: "st88",
    width: 4.3,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 103.1,
    className: "st89",
    width: 3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 101.9,
    className: "st89",
    width: 0.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.2,
    y: 102.2,
    className: "st89",
    width: 0.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.4,
    y: 101.9,
    className: "st89",
    width: 0.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 102.2,
    className: "st89",
    width: 0.5,
    height: 1.5
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 91,
    className: "st17",
    width: 18,
    height: 0.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 98,
    className: "st17",
    width: 18,
    height: 0.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 90.5,
    width: 18,
    height: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 98.9,
    width: 18,
    height: 0.5
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "SN755410NE"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 91.2,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 97.1,
    className: "st48",
    width: 0.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "42,98 24,98 24.1,96 42,96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42,93.8 24.1,93.8 24,91.9 42,91.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "40,97.6 40,97.9 40.5,98.1 41.2,98.1 41.2,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "24.7,97.6 24.7,98.1 25.4,98.1 25.9,97.9 25.9,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "41.2,92.2 41.2,91.7 40.5,91.7 40,91.9 40,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "25.9,92.2 25.9,91.9 25.4,91.7 24.7,91.7 24.7,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "37.8,97.6 37.8,97.9 38.2,98.1 38.9,98.1 39.4,97.9 39.4,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "39.4,92.2 39.4,91.9 38.9,91.7 38.2,91.7 37.8,91.9 37.8,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "35.5,97.6 35.5,97.9 36,98.1 36.7,98.1 37.1,97.9 37.1,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "37.1,92.2 37.1,91.9 36.7,91.7 36,91.7 35.5,91.9 35.5,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "33.3,97.6 33.3,97.9 33.7,98.1 34.4,98.1 34.9,97.9 34.9,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "34.9,92.2 34.9,91.9 34.4,91.7 33.7,91.7 33.3,91.9 33.3,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "31,97.6 31,97.9 31.5,98.1 32.2,98.1 32.6,97.9 32.6,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "32.6,92.2 32.6,91.9 32.2,91.7 31.5,91.7 31,91.9 31,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "28.8,97.6 28.8,97.9 29.2,98.1 29.9,98.1 30.4,97.9 30.4,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "30.4,92.2 30.4,91.9 29.9,91.7 29.2,91.7 28.8,91.9 28.8,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "26.5,97.6 26.5,97.9 27,98.1 27.7,98.1 28.1,97.9 28.1,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "28.1,92.2 28.1,91.9 27.7,91.7 27,91.7 26.5,91.9 26.5,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "24,98 24.1,97.4 24.4,97.4 24.4,92.4 24.1,92.4 24,91.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "42,98 41.8,97.4 41.8,96 40.8,96 40.8,93.8 41.8,93.8 41.8,92.4 42,91.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "40.8,96 41.8,96 41.8,95.6 41.8,94.9 40.8,94.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "41.8,93.8 40.8,93.8 40.8,94.9 41.8,94.9 41.8,94.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M41.8,97.4V96c-0.5-0.1-0.9-0.6-0.9-1.1s0.4-1,0.9-1.1v-1.3H24.1v5H41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M41.8,95.6v-1.3c-0.3,0-0.6,0.3-0.6,0.7C41.2,95.3,41.5,95.5,41.8,95.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st94",
    cx: 40.5,
    cy: 93.3,
    r: 0.5
  }))), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    id: "connector657pin",
    className: "st47",
    cx: 12.4,
    cy: 64.4,
    r: 0.9
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "st84",
    cx: 14.7,
    cy: 64.4,
    r: 1.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "connector658pin",
    className: "st89",
    d: "M14.7,66.1L14.7,66.1c-0.2,0-0.3-0.1-0.3-0.3v-2.9c0-0.2,0.1-0.3,0.3-0.3h0 c0.2,0,0.3,0.1,0.3,0.3v2.9C15,66,14.9,66.1,14.7,66.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEviveIllustration);
export default __webpack_public_path__ + "static/media/icon-evive-illustration.a7b2ce2a8b73136c755686dc25306db3.svg";
export { ForwardRef as ReactComponent };